(function () {
  if (window.__amcInvitesMapBoot) {
    window.__amcInvitesMapBoot();
    return;
  }

  /* Figma 177:1314 — store Group 1321324687, popup Group 1321324688 (48×61) */
  var STORE_PIN_BUBBLE =
    'M24.0049 0C30.3691 0.00720754 36.4705 2.53487 40.9707 7.02734C45.4709 11.52 48.0025 17.6113 48.0098 23.9648C48.0098 44.4709 26.187 59.9583 25.2568 60.6064C24.8899 60.863 24.4528 61 24.0049 61C23.557 61 23.1198 60.863 22.7529 60.6064C21.8227 59.9583 0 44.4709 0 23.9648C0.00726456 17.6113 2.53883 11.52 7.03906 7.02734C11.5393 2.53486 17.6407 0.00721543 24.0049 0Z';
  var STORE_PIN_ICON =
    'M36.9437 22.7262L35.1512 16.45C35.0306 16.0336 34.7786 15.6675 34.4328 15.4061C34.087 15.1448 33.6659 15.0023 33.2324 15H14.7324C14.299 15.0023 13.8779 15.1448 13.5321 15.4061C13.1862 15.6675 12.9342 16.0336 12.8137 16.45L11.0212 22.7262C10.9955 22.8152 10.9825 22.9074 10.9824 23V25C10.9824 25.7762 11.1631 26.5418 11.5103 27.2361C11.8574 27.9303 12.3614 28.5343 12.9824 29V38C12.9824 38.2652 13.0878 38.5196 13.2753 38.7071C13.4629 38.8946 13.7172 39 13.9824 39H33.9824C34.2476 39 34.502 38.8946 34.6895 38.7071C34.8771 38.5196 34.9824 38.2652 34.9824 38V29C35.6034 28.5343 36.1074 27.9303 36.4546 27.2361C36.8017 26.5418 36.9824 25.7762 36.9824 25V23C36.9823 22.9074 36.9693 22.8152 36.9437 22.7262ZM18.9824 25C18.9822 25.5159 18.849 26.023 18.5957 26.4724C18.3423 26.9217 17.9773 27.2982 17.536 27.5653C17.0947 27.8325 16.5919 27.9813 16.0763 27.9975C15.5607 28.0136 15.0496 27.8965 14.5924 27.6575C14.5229 27.6034 14.4463 27.5588 14.3649 27.525C13.9413 27.2538 13.5926 26.8804 13.351 26.4392C13.1094 25.9979 12.9827 25.503 12.9824 25V24H18.9824V25ZM26.9824 25C26.9824 25.7956 26.6664 26.5587 26.1037 27.1213C25.5411 27.6839 24.7781 28 23.9824 28C23.1868 28 22.4237 27.6839 21.8611 27.1213C21.2985 26.5587 20.9824 25.7956 20.9824 25V24H26.9824V25ZM34.9824 25C34.982 25.5032 34.8551 25.9981 34.6133 26.4394C34.3715 26.8806 34.0226 27.2539 33.5987 27.525C33.5183 27.5589 33.4427 27.603 33.3737 27.6562C32.9166 27.8955 32.4055 28.0129 31.8898 27.9969C31.374 27.981 30.8712 27.8323 30.4297 27.5653C29.9882 27.2982 29.6231 26.9218 29.3696 26.4725C29.1161 26.0231 28.9827 25.516 28.9824 25V24H34.9824V25Z';
  var POPUP_PIN_BUBBLE =
    'M24 0C30.3629 0.00720768 36.4636 2.5347 40.9629 7.02734C45.4621 11.52 47.9927 17.6113 48 23.9648C48 44.4709 26.1819 59.9583 25.252 60.6064C24.8851 60.863 24.4478 61 24 61C23.5522 60.9999 23.1148 60.863 22.748 60.6064C21.8151 59.9562 0 44.4694 0 23.9648C0.00726273 17.6113 2.53885 11.52 7.03809 7.02734C11.5373 2.53488 17.6373 0.00728865 24 0Z';
  var POPUP_PIN_ICON =
    'M37.3813 16.9438C37.2912 16.8011 37.1665 16.6835 37.0187 16.602C36.871 16.5205 36.705 16.4776 36.5363 16.4775H12.5363C12.3384 16.4774 12.1449 16.5359 11.9803 16.6458C11.8157 16.7557 11.6874 16.9119 11.6116 17.0947C11.5359 17.2776 11.5161 17.4788 11.5547 17.6728C11.5934 17.8669 11.6888 18.0452 11.8288 18.185L17.1225 23.4775L11.8288 28.77C11.6888 28.9099 11.5934 29.0881 11.5547 29.2822C11.5161 29.4763 11.5359 29.6775 11.6116 29.8603C11.6874 30.0432 11.8157 30.1994 11.9803 30.3093C12.1449 30.4191 12.3384 30.4777 12.5363 30.4775H29.2388L25.6338 38.0475C25.5735 38.1665 25.5376 38.2963 25.5283 38.4294C25.5189 38.5624 25.5362 38.696 25.5793 38.8222C25.6223 38.9485 25.6902 39.0648 25.7789 39.1644C25.8675 39.2641 25.9753 39.3449 26.0957 39.4023C26.2161 39.4597 26.3467 39.4924 26.48 39.4985C26.6132 39.5046 26.7463 39.484 26.8715 39.4379C26.9966 39.3918 27.1113 39.3211 27.2087 39.23C27.3061 39.139 27.3844 39.0293 27.4388 38.9075L37.4388 17.9075C37.5113 17.7551 37.5441 17.5868 37.534 17.4183C37.524 17.2497 37.4714 17.0865 37.3813 16.9438ZM30.19 28.4775H14.95L19.2438 24.185C19.3367 24.0922 19.4105 23.9819 19.4608 23.8605C19.5112 23.7391 19.5371 23.609 19.5371 23.4775C19.5371 23.3461 19.5112 23.216 19.4608 23.0946C19.4105 22.9732 19.3367 22.8629 19.2438 22.77L14.95 18.4775H34.95L30.19 28.4775Z';

  function storePinSvg() {
    return (
      '<path d="' +
      STORE_PIN_BUBBLE +
      '" fill="var(--amc-map-pin-store-bubble, #fff)"/>' +
      '<path d="' +
      STORE_PIN_ICON +
      '" fill="var(--amc-map-pin-store-icon, #C99395)"/>'
    );
  }

  function popupPinSvg() {
    return (
      '<path d="' +
      POPUP_PIN_BUBBLE +
      '" fill="var(--amc-map-pin-popup-fill, #603338)" fill-opacity="var(--amc-map-pin-popup-fill-opacity, 0.1)"/>' +
      '<path d="' +
      POPUP_PIN_ICON +
      '" fill="var(--amc-map-pin-popup-icon, #603338)"/>'
    );
  }

  var STORE_PIN_SVG = storePinSvg();
  var POPUP_PIN_SVG = popupPinSvg();

  var MAP_PIN_BASE_SCALE = 1;
  var MOBILE_MAP_MQ = '(max-width: 767px)';
  var MOBILE_PIN_VISUAL_MULTIPLIER = 1;
  function isMobileMapViewport() {
    try {
      return window.matchMedia(MOBILE_MAP_MQ).matches;
    } catch (_error) {
      return false;
    }
  }

  function isDualPinState(location) {
    if (!location) return false;
    var code = String(location.stateCode || '')
      .trim()
      .toUpperCase();
    return code === 'CA' || code === 'VA';
  }

  function locationsForMapPins(locations) {
    /*
     * Default: one pin per state.
     * Permanent-shop states (CA / VA): store pin + popup flag pin.
     */
    var byState = {};
    (locations || []).forEach(function (location) {
      if (location.stateIndex == null) return;
      var key = String(location.stateIndex);
      if (!byState[key]) byState[key] = [];
      byState[key].push(location);
    });

    var pins = [];
    Object.keys(byState).forEach(function (key) {
      var group = byState[key].slice().sort(function (a, b) {
        var typeA = resolveInvitesPinType(a) === 'store' ? 0 : 1;
        var typeB = resolveInvitesPinType(b) === 'store' ? 0 : 1;
        if (typeA !== typeB) return typeA - typeB;
        var parentA = a.parentId ? 1 : 0;
        var parentB = b.parentId ? 1 : 0;
        if (parentA !== parentB) return parentA - parentB;
        return invitesCityPreference(a) - invitesCityPreference(b);
      });

      var store = group.find(function (location) {
        return resolveInvitesPinType(location) === 'store';
      });
      var popup = group.find(function (location) {
        return resolveInvitesPinType(location) !== 'store';
      });
      var dual = group.some(isDualPinState);

      if (dual && store) {
        pins.push(store);
        if (popup) {
          pins.push(popup);
        } else {
          pins.push(
            Object.assign({}, store, {
              id: String(store.id || 'state') + '-popup-map',
              type: 'popup',
              parentId: store.id,
              __forcePinType: 'popup',
              workshops: store.workshops || [],
            })
          );
        }
        return;
      }

      pins.push(store || group[0]);
    });

    return pins;
  }

  function getVisualPinMultiplier(section) {
    if (!isMobileMapViewport()) return 1;
    if (!section) return MOBILE_PIN_VISUAL_MULTIPLIER;
    var computed = window.getComputedStyle(section);
    var cssMult = parseFloat(computed.getPropertyValue('--amc-map-pin-mobile-multiplier'));
    return !isNaN(cssMult) && cssMult > 0 ? cssMult : MOBILE_PIN_VISUAL_MULTIPLIER;
  }

  /* Designed pin tips removed — pins are placed at state centers via layoutLocationsFromStateBounds. */

  /* Extra designed pins that stay inside the same state. */
  function getStateSlotPool(stateEl, svg) {
    if (stateEl.__amcPinSlots && stateEl.__amcPinSlots.length) return stateEl.__amcPinSlots;
    var box = stateEl.getBBox();
    var slots = [];
    var cols = 10;
    var rows = 10;
    var padX = box.width * 0.16;
    var padY = box.height * 0.16;
    var innerW = Math.max(1, box.width - padX * 2);
    var innerH = Math.max(1, box.height - padY * 2);
    var row;
    var col;
    for (row = 0; row < rows; row++) {
      for (col = 0; col < cols; col++) {
        var x = box.x + padX + (innerW * (col + 0.5)) / cols;
        var y = box.y + padY + (innerH * (row + 0.5)) / rows;
        if (pinAnchorTipFits(stateEl, svg, x, y)) slots.push({ x: x, y: y });
      }
    }
    stateEl.__amcPinSlots = slots;
    return slots;
  }

  function takeSpreadSlots(pool, count, reserved) {
    if (!pool.length || count < 1) return [];
    var used = (reserved || []).slice();
    var picked = [];
    var i;
    for (i = 0; i < count; i++) {
      var targetIndex = Math.round(((i + 0.5) * pool.length) / count - 0.5);
      targetIndex = Math.max(0, Math.min(pool.length - 1, targetIndex));
      var chosen = null;
      var offset;
      for (offset = 0; offset < pool.length; offset++) {
        var candidate = pool[(targetIndex + offset) % pool.length];
        if (used.some(function (point) { return distanceBetween(point, candidate) < 36; })) continue;
        chosen = candidate;
        break;
      }
      if (!chosen) chosen = pool[targetIndex];
      picked.push(chosen);
      used.push(chosen);
    }
    return picked;
  }

  /* AMC West: amc-invites-map.svg — stateIndex 0 = AZ … 8 = MT. */
  var DEFAULT_STATE_COLORS = [
    '#F4F1E2',
    '#F4F1E2',
    '#F4F1E2',
    '#F4F1E2',
    '#F4F1E2',
    '#F4F1E2',
    '#F4F1E2',
    '#F4F1E2',
    '#F4F1E2',
    '#F4F1E2',
    '#F4F1E2',
    '#F4F1E2',
    '#F4F1E2',
    '#F4F1E2',
    '#F4F1E2',
    '#F4F1E2',
    '#F4F1E2',
  ];

  function parseStateColors(section) {
    var raw = section.getAttribute('data-amc-invites-state-colors');
    if (!raw) return DEFAULT_STATE_COLORS.slice();

    try {
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return DEFAULT_STATE_COLORS.slice();
      return parsed.map(function (value, index) {
        var fallback = DEFAULT_STATE_COLORS[index] || '#F4F1E2';
        return typeof value === 'string' && value.trim() ? value.trim() : fallback;
      });
    } catch (_error) {
      return DEFAULT_STATE_COLORS.slice();
    }
  }

  function normalizeColor(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getMapBaseFill(section) {
    if (!section) return '#F4F1E2';
    var base = window.getComputedStyle(section).getPropertyValue('--amc-map-state-fill').trim();
    return base || '#F4F1E2';
  }

  function getMapActiveFill(section) {
    if (!section) return '#D2ADB5';
    var active = window.getComputedStyle(section).getPropertyValue('--amc-map-state-active').trim();
    return active || '#D2ADB5';
  }

  function resolveStateColor(stateColors, stateIndex, section) {
    var color = stateColors[stateIndex];
    var baseFill = getMapBaseFill(section);
    if (color && normalizeColor(color) !== normalizeColor(baseFill)) {
      return color.trim();
    }
    return getMapActiveFill(section);
  }

  function getMapStateEl(states, stateIndex) {
    if (stateIndex == null || isNaN(stateIndex)) return null;
    var index = parseInt(stateIndex, 10);
    if (states[index] && parseInt(states[index].getAttribute('data-state-index'), 10) === index) {
      return states[index];
    }

    for (var i = 0; i < states.length; i++) {
      if (parseInt(states[i].getAttribute('data-state-index'), 10) === index) {
        return states[i];
      }
    }

    return null;
  }

  function resetMapStateFills(states, section) {
    var baseFill = getMapBaseFill(section);
    states.forEach(function (stateEl) {
      stateEl.style.setProperty('--amc-map-state-assigned', baseFill);
      stateEl.style.removeProperty('fill');
    });
  }

  function applyActiveMapStateFill(states, stateIndex, stateColors, section) {
    resetMapStateFills(states, section);
    var activeState = getMapStateEl(states, stateIndex);
    if (!activeState) return;

    var activeFill = resolveStateColor(stateColors, stateIndex, section);
    activeState.style.setProperty('--amc-map-state-assigned', activeFill);
    activeState.style.setProperty('fill', activeFill);
  }

  function applyStateTheme(section, stateIndex, stateColors) {
    if (!section) return;
    var color = resolveStateColor(stateColors, stateIndex, section);

    section.style.setProperty('--amc-invites-stamp-border', color);
    section.style.setProperty('--amc-invites-button-bg', color);
    section.style.setProperty('--amc-invites-compare-price-color', color);
    section.setAttribute('data-amc-invites-active-state', String(stateIndex));
  }

  function lockMapSvgAspect(mapRoot) {
    var svg = mapRoot && mapRoot.querySelector('svg');
    if (!svg) return;
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    svg.setAttribute('viewBox', svg.getAttribute('viewBox') || '0 0 680 720');
    svg.removeAttribute('width');
    svg.removeAttribute('height');
    svg.querySelectorAll('.amc-map__pin:not(.amc-map__pin--dynamic):not(.amc-map__pin--ssr)').forEach(function (pin) {
      pin.remove();
    });
  }

  function loadMapSvg(mapRoot) {
    if (mapRoot.querySelector('svg')) {
      lockMapSvgAspect(mapRoot);
      return Promise.resolve();
    }

    if (mapRoot.__amcMapSvgPromise) {
      return mapRoot.__amcMapSvgPromise;
    }

    var src = mapRoot.getAttribute('data-amc-invites-map-src');
    if (!src) {
      return Promise.resolve();
    }

    mapRoot.__amcMapSvgPromise = fetch(src)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Map SVG failed to load');
        }
        return response.text();
      })
      .then(function (svgText) {
        /* Second concurrent fetch must not wipe pins built by the first init. */
        if (mapRoot.querySelector('svg')) {
          lockMapSvgAspect(mapRoot);
          return;
        }
        mapRoot.innerHTML = svgText;
        mapRoot.setAttribute('role', 'group');
        lockMapSvgAspect(mapRoot);
      })
      .catch(function () {
        if (mapRoot.querySelector('svg') || mapRoot.querySelector('img.amc-invites__map-fallback')) {
          return;
        }
        var img = document.createElement('img');
        img.src = src;
        img.alt = mapRoot.getAttribute('aria-label') || '';
        img.className = 'amc-invites__map-fallback';
        img.width = 1078;
        img.height = 984;
        mapRoot.appendChild(img);
      });

    return mapRoot.__amcMapSvgPromise;
  }

  var INVITES_STATE_NAME_TO_CODE = {
    arizona: 'AZ',
    california: 'CA',
    washington: 'WA',
    oregon: 'OR',
    nevada: 'NV',
    utah: 'UT',
    texas: 'TX',
    idaho: 'ID',
    montana: 'MT',
    colorado: 'CO',
    michigan: 'MI',
    indiana: 'IN',
    ohio: 'OH',
    pennsylvania: 'PA',
    'west virginia': 'WV',
    virginia: 'VA',
    maryland: 'MD',
    delaware: 'DE',
    'new jersey': 'NJ',
    'new york': 'NY',
    connecticut: 'CT',
    'rhode island': 'RI',
    massachusetts: 'MA',
    vermont: 'VT',
    'new hampshire': 'NH',
    maine: 'ME',
    'north carolina': 'NC',
  };

  var INVITES_WEST_STATE_INDEX_NAMES = [
    'Arizona',
    'California',
    'Washington',
    'Oregon',
    'Nevada',
    'Utah',
    'Texas',
    'Idaho',
    'Montana',
  ];

  var INVITES_EAST_STATE_INDEX_NAMES = [
    'Michigan',
    'Indiana',
    'Ohio',
    'Pennsylvania',
    'West Virginia',
    'Virginia',
    'Maryland',
    'Delaware',
    'New Jersey',
    'New York',
    'Connecticut',
    'Rhode Island',
    'Massachusetts',
    'Vermont',
    'New Hampshire',
    'Maine',
    'North Carolina',
  ];

  function getStateNamesForSection(section) {
    var region = section && section.getAttribute
      ? String(section.getAttribute('data-amc-invites-region') || 'west').toLowerCase()
      : 'west';
    return region === 'east' ? INVITES_EAST_STATE_INDEX_NAMES : INVITES_WEST_STATE_INDEX_NAMES;
  }

  function getStateDisplayName(stateIndex, section) {
    var names = getStateNamesForSection(section);
    if (names[stateIndex]) {
      return names[stateIndex];
    }
    return 'State';
  }

  var INVITES_WORKSHOP_TYPE_ORDER = { mosaic: 0, flower: 1, resin: 2, ceramic: 3, workshop: 4 };
  var INVITES_WORKSHOP_DESCRIPTIONS = {
    mosaic:
      'Learn to design and create your own traditional Turkish Mosaic Lamp in a 2.5-hour class, including techniques for assembling geometric patterns and laying tiles.',
    flower: 'Create a decorative floral piece in a calm, beginner-friendly workshop.',
    ceramic: 'Paint your own ceramic piece in a relaxed studio session with guided instruction.',
    resin: 'Create a one-of-a-kind resin artwork with premium pigments and finishing.',
  };

  var INVITES_COLLECTION_TO_STATE = {
    'maine-workshops': 'ME',
    'new-hampshire-workshops': 'NH',
    'vermont-workshops': 'VT',
    'new-jersey-workshops': 'NJ',
    'rhode-island-workshops': 'RI',
    'massachusetts-workshops': 'MA',
    'connecticut-workshops': 'CT',
    'new-york-workshops': 'NY',
    'pennsylvania-workshops': 'PA',
    'virginia-workshops': 'VA',
    'west-virginia-workshops': 'WV',
    'maryland-workshops': 'MD',
    'north-carolina-workshops': 'NC',
    'ohio-workshops': 'OH',
    'michigan-workshops': 'MI',
    'indiana-workshops': 'IN',
    'delaware-workshops': 'DE',
    'district-of-columbia-workshops': 'DC',
    'california-workshops': 'CA',
    'washington-workshops': 'WA',
    'texas-workshops': 'TX',
    'arizona-workshops': 'AZ',
    'oregon-workshops': 'OR',
    'nevada-workshops': 'NV',
    'utah-workshops': 'UT',
    'idaho-workshops': 'ID',
    'montana-workshops': 'MT',
    'colorado-workshops': 'CO',
  };

  // Ajax /collections/.../products.json returns variant.price as dollars ("79.00"), not cents.
  function formatInvitesMoney(amount) {
    if (amount == null || amount === '') return '';
    var value = Number(amount);
    if (isNaN(value)) return '';
    return '$' + value.toFixed(2);
  }

  function inferCityFromProductTitle(title) {
    var text = String(title || '').trim();
    if (!text) return '';

    var inMatch = text.match(/\s+in\s+(.+?)(?:\s*[-–|(,]|$)/i);
    if (inMatch) return inMatch[1].trim();

    inMatch = text.match(/\s+in\s+(.+)$/i);
    return inMatch ? inMatch[1].trim() : '';
  }

  function looksLikeStateName(value) {
    var normalized = normalizeInvitesCityName(value);
    if (!normalized) return false;
    if (INVITES_STATE_NAME_TO_CODE[normalized]) return true;
    if (normalized.length !== 2) return false;
    return (
      'AZ CA WA OR NV UT TX ID MT CO MI IN OH PA WV VA MD DE NJ NY CT RI MA VT NH ME NC DC'
        .split(' ')
        .indexOf(normalized.toUpperCase()) !== -1
    );
  }

  function looksLikeWorkshopTitle(value) {
    return /(workshop|class|painting|pop-?up|resin art|mosaic|ceramic|flower|floral)/i.test(
      String(value || '')
    );
  }

  function productCityLabel(product) {
    var city = String((product && product.cityName) || '').trim();
    var title = String((product && product.title) || '').trim();
    var inferred = inferCityFromProductTitle(title);

    if (city && city !== title && !looksLikeWorkshopTitle(city) && !looksLikeStateName(city)) {
      return city;
    }
    if (inferred && !looksLikeStateName(inferred) && !looksLikeWorkshopTitle(inferred)) {
      return inferred;
    }
    return '';
  }

  function regexEscape(value) {
    return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function workshopLocationNames(location, workshop) {
    var names = [];

    if (location && location.title) names.push(String(location.title).trim());
    if (location && location.cityNames && location.cityNames.length) {
      location.cityNames.forEach(function (name) {
        if (name) names.push(String(name).trim());
      });
    }
    if (workshop && workshop.cityName) names.push(String(workshop.cityName).trim());
    if (workshop && workshop.cityNameNormalized) names.push(String(workshop.cityNameNormalized).trim());

    var unique = [];
    names.forEach(function (name) {
      if (!name) return;
      var normalized = normalizeInvitesCityName(name);
      if (unique.indexOf(name) === -1) unique.push(name);
      if (normalized && unique.indexOf(normalized) === -1) unique.push(normalized);
    });

    return unique.sort(function (a, b) {
      return b.length - a.length;
    });
  }

  function stripLocationFromWorkshopTitle(title, location, workshop) {
    var text = String(title || '').trim();
    if (!text) return text;

    var names = workshopLocationNames(location, workshop);
    if (!names.length) return text;

    names.forEach(function (city) {
      var escaped = regexEscape(city);
      var patterns = [
        new RegExp('\\s+in\\s+' + escaped + '\\s*$', 'i'),
        new RegExp('\\s+in\\s+' + escaped + '(?=\\s*[-–|(,])', 'i'),
        new RegExp('\\s+[-–|]\\s*' + escaped + '\\s*$', 'i'),
        new RegExp('\\s+' + escaped + '\\s*$', 'i'),
        new RegExp('^' + escaped + '\\s*[-–|:]\\s*', 'i'),
      ];

      patterns.forEach(function (pattern) {
        text = text.replace(pattern, '');
      });
    });

    return text.replace(/\s{2,}/g, ' ').replace(/\s+([,.!?])/g, '$1').trim();
  }

  function workshopCardTitle(workshop) {
    var type = normalizeWorkshopType(workshop);
    if (type === 'flower') return 'Flower Decorating Workshop';
    if (type === 'resin') return 'Resin Workshop';
    if (type === 'ceramic') return 'Ceramic Workshop';
    if (type === 'mosaic') return 'Mosaic Workshop';

    return stripLocationFromWorkshopTitle(workshop && workshop.title, null, workshop);
  }

  function firstInvitesValue(values) {
    return values && values.length ? String(values[0] || '').trim() : '';
  }

  function appendInvitesUrlParams(url, params) {
    if (!url) return '';

    var pairs = [];
    Object.keys(params || {}).forEach(function (key) {
      var value = params[key];
      if (value == null || value === '') return;
      pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(String(value)));
    });

    if (!pairs.length) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + pairs.join('&');
  }

  function locationAwareProductUrl(url, location, product) {
    var city = String(
      (product && product.cityName) ||
        (location && location.title) ||
        firstInvitesValue(location && location.cityNames) ||
        ''
    ).trim();
    if (!city) return url || '';

    var subtitle = String((location && location.subtitle) || '').trim();
    var stateName = subtitle.split(',')[0].trim();
    var cityKey = firstInvitesValue(location && location.cityKeys);
    var productCityKey = String((product && product.cityKey) || '').trim();

    return appendInvitesUrlParams(url || '', {
      amc_city: city,
      amc_state: stateName,
      amc_state_code: location && location.stateCode,
      amc_city_key: productCityKey || cityKey,
      amc_venue_id: productCityKey || cityKey || (location && location.id),
    });
  }

  function workshopDisplayCity(workshop, location) {
    var fromProduct = productCityLabel(workshop);
    if (fromProduct) return fromProduct;
    var raw = String((workshop && workshop.cityName) || '').trim();
    if (raw && !looksLikeWorkshopTitle(raw) && !looksLikeStateName(raw)) {
      return raw;
    }
    return String((location && location.title) || '').trim();
  }

  function workshopDisplaySubtitle(workshop, location) {
    if (location && location.subtitle) {
      return String(location.subtitle).trim();
    }
    var code = String((location && location.stateCode) || (workshop && workshop.stateCode) || '')
      .trim()
      .toUpperCase();
    var name = '';
    if (workshop && workshop.state && String(workshop.state).trim().length > 2) {
      name = String(workshop.state).trim();
    }
    if (!name && code) {
      Object.keys(INVITES_STATE_NAME_TO_CODE).some(function (key) {
        if (INVITES_STATE_NAME_TO_CODE[key] === code) {
          name = key.replace(/\b\w/g, function (ch) {
            return ch.toUpperCase();
          });
          return true;
        }
        return false;
      });
    }
    if (name && code) return name + ', ' + code;
    if (code) return code;
    return '';
  }

  function enrichCatalogProduct(product) {
    if (!product) return product;

    var enriched = Object.assign({}, product);
    var collectionState = '';

    if (enriched.sourceCollection) {
      collectionState =
        INVITES_COLLECTION_TO_STATE[String(enriched.sourceCollection).toLowerCase()] || '';
      if (collectionState) {
        enriched.stateCode = collectionState;
        enriched.state = collectionState;
      }
    }

    if (!enriched.cityName) {
      enriched.cityName = inferCityFromProductTitle(enriched.title);
    }
    if (!enriched.cityNameNormalized) {
      enriched.cityNameNormalized = normalizeInvitesCityName(enriched.cityName || enriched.title);
    }
    if (!enriched.stateCode && collectionState) {
      enriched.stateCode = collectionState;
    }
    if (!enriched.state && enriched.stateCode) {
      enriched.state = enriched.stateCode;
    }
    if (!enriched.url && enriched.handle) {
      enriched.url = '/products/' + enriched.handle;
    }
    if (!enriched.workshopType) {
      enriched.workshopType = invitesCatalogWorkshopType(enriched);
    }

    return enriched;
  }

  function mapStorefrontProduct(raw, collectionHandle) {
    var variant = raw && raw.variants && raw.variants[0] ? raw.variants[0] : null;
    var price = variant ? variant.price : null;
    var compareAt = variant && variant.compare_at_price ? variant.compare_at_price : null;
    var image = '';

    if (raw.featured_image) {
      image = raw.featured_image;
    } else if (raw.images && raw.images[0] && raw.images[0].src) {
      image = raw.images[0].src;
    }

    return enrichCatalogProduct({
      id: raw.id,
      handle: raw.handle,
      title: raw.title || '',
      url: '/products/' + raw.handle,
      description: '',
      cityName: inferCityFromProductTitle(raw.title),
      cityKey: '',
      state: '',
      stateCode: INVITES_COLLECTION_TO_STATE[String(collectionHandle).toLowerCase()] || '',
      workshopType: '',
      price: formatInvitesMoney(price),
      compareAtPrice:
        compareAt && Number(compareAt) > Number(price) ? formatInvitesMoney(compareAt) : '',
      image: image,
      sourceCollection: collectionHandle,
    });
  }

  function getCatalogCollectionHandles(catalog) {
    var master = catalog && catalog.collectionHandle ? String(catalog.collectionHandle).trim() : '';
    if (master) return [master];

    if (catalog && Array.isArray(catalog.sourceCollections)) {
      var source = catalog.sourceCollections.find(function (item) {
        return item && item.handle && Number(item.productCount) > 0;
      });
      if (source) return [String(source.handle).trim()];
    }

    return [];
  }

  function fetchCollectionCatalogProducts(handle) {
    var url = '/collections/' + encodeURIComponent(handle) + '/products.json?limit=250';

    return fetch(url)
      .then(function (response) {
        if (!response.ok) {
          return { products: [] };
        }
        return response.json();
      })
      .then(function (data) {
        return (data.products || []).map(function (product) {
          return mapStorefrontProduct(product, handle);
        });
      })
      .catch(function () {
        return [];
      });
  }

  function hydrateInvitesCatalog(catalog) {
    catalog = catalog || { products: [], buttonLabel: 'Book now' };
    var liquidProducts = (catalog.products || []).map(enrichCatalogProduct);
    var handles = getCatalogCollectionHandles(catalog);
    var printedCount = Number(catalog.catalogCount) || liquidProducts.length;

    /* Liquid already printed the catalog — never hit /collections/.../products.json. */
    if (liquidProducts.length || printedCount > 0 || catalog.skipAjax) {
      return Promise.resolve(
        Object.assign({}, catalog, {
          products: liquidProducts,
          catalogCount: liquidProducts.length || printedCount,
        })
      );
    }

    if (!handles.length) {
      return Promise.resolve(
        Object.assign({}, catalog, {
          products: liquidProducts,
          catalogCount: liquidProducts.length,
        })
      );
    }

    return Promise.all(handles.map(fetchCollectionCatalogProducts)).then(function (groups) {
      var merged = liquidProducts.slice();
      var seen = {};

      liquidProducts.forEach(function (product) {
        if (product && product.id) {
          seen[product.id] = true;
        }
      });

      groups.forEach(function (group) {
        group.forEach(function (product) {
          if (!product || !product.id || seen[product.id]) return;
          seen[product.id] = true;
          merged.push(enrichCatalogProduct(product));
        });
      });

      return Object.assign({}, catalog, {
        products: merged,
        catalogCount: merged.length,
        hydratedFromStorefront: merged.length > liquidProducts.length,
      });
    }).catch(function () {
      return Object.assign({}, catalog, {
        products: liquidProducts,
        catalogCount: liquidProducts.length,
      });
    });
  }

  function readInvitesCatalog(section) {
    var el = section.querySelector('[data-amc-invites-catalog]');
    if (!el || !el.textContent) {
      return { products: [], buttonLabel: 'Book now' };
    }

    try {
      return JSON.parse(el.textContent);
    } catch (_error) {
      return { products: [], buttonLabel: 'Book now' };
    }
  }

  function normalizeInvitesList(values) {
    if (!values) return [];
    if (Array.isArray(values)) {
      return values
        .map(function (value) {
          return String(value || '')
            .trim()
            .toLowerCase();
        })
        .filter(Boolean);
    }
    return String(values || '')
      .split(',')
      .map(function (value) {
        return value.trim().toLowerCase();
      })
      .filter(Boolean);
  }

  function normalizeInvitesCityName(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function invitesLocationNames(location) {
    var names = normalizeInvitesList(location.cityNames);
    if (location.title) {
      names.push(normalizeInvitesCityName(location.title));
    }
    return names.filter(function (name, index, list) {
      return name && list.indexOf(name) === index;
    });
  }

  function invitesCitiesMatch(productCity, locationNames) {
    var city = normalizeInvitesCityName(productCity);
    if (!city || !locationNames.length) {
      return false;
    }

    for (var i = 0; i < locationNames.length; i++) {
      var loc = locationNames[i];
      if (!loc) continue;
      if (city === loc) return true;
      if (city.indexOf(loc) >= 0 || loc.indexOf(city) >= 0) return true;
    }

    return false;
  }

  function resolveInvitesProductStateCode(product) {
    var fromField = String((product && product.stateCode) || '')
      .trim()
      .toUpperCase();
    if (fromField.length === 2) {
      return fromField;
    }

    var raw = String((product && product.state) || '')
      .trim()
      .toUpperCase();
    if (raw.length === 2) {
      return raw;
    }
    var fromName = INVITES_STATE_NAME_TO_CODE[String((product && product.state) || '').trim().toLowerCase()];
    if (fromName) {
      return fromName;
    }

    var fromCollection =
      INVITES_COLLECTION_TO_STATE[String((product && product.sourceCollection) || '').toLowerCase()] || '';
    return fromCollection || raw;
  }

  function productMatchesInvitesLocation(product, location) {
    if (!product || !location) return false;

    var locationState = String(location.stateCode || '')
      .trim()
      .toUpperCase();
    var productState = resolveInvitesProductStateCode(product);
    if (locationState && productState && productState !== locationState) {
      return false;
    }

    var cityKey = String(product.cityKey || '')
      .trim()
      .toLowerCase();
    var locationKeys = normalizeInvitesList(location.cityKeys);
    if (cityKey && locationKeys.length && locationKeys.indexOf(cityKey) !== -1) {
      return true;
    }

    var locationNames = invitesLocationNames(location);
    var productCity = product.cityNameNormalized || product.cityName;
    if (invitesCitiesMatch(productCity, locationNames)) {
      return true;
    }

    if (invitesCitiesMatch(product.title, locationNames)) {
      return true;
    }

    return false;
  }

  function productMatchesInvitesLocationState(product, location) {
    if (!product || !location) return false;

    var locationState = String(location.stateCode || '')
      .trim()
      .toUpperCase();
    var productState = resolveInvitesProductStateCode(product);

    return !!(locationState && productState && productState === locationState);
  }

  function invitesCatalogWorkshopType(product) {
    var type = String((product && product.workshopType) || '')
      .toLowerCase()
      .trim();
    if (type === 'resin' || type === 'ceramic' || type === 'mosaic' || type === 'flower') {
      return type;
    }
    if (type === 'workshop') {
      type = '';
    }
    return normalizeWorkshopType({
      type: type,
      title: product.title,
      handle: product.handle,
    });
  }

  function locationWorkshopByType(location, type) {
    var match = null;
    (location && location.workshops ? location.workshops : []).some(function (workshop) {
      if (String((workshop && workshop.type) || '').toLowerCase() === type) {
        match = workshop;
        return true;
      }
      return false;
    });
    return match;
  }

  function catalogProductToWorkshop(product, catalog, location) {
    var workshopType = invitesCatalogWorkshopType(product);
    var template = locationWorkshopByType(location, workshopType);
    var description = String(product.description || '').trim();
    if (!description && template && template.description) {
      description = String(template.description).trim();
    }
    if (!description) {
      description = INVITES_WORKSHOP_DESCRIPTIONS[workshopType] || '';
    }
    return {
      type: workshopType,
      workshopType: workshopType,
      title: product.title || '',
      description: description,
      price: product.price || '',
      compareAtPrice: product.compareAtPrice || '',
      buttonLabel: (template && template.buttonLabel) || catalog.buttonLabel || 'Book now',
      link: locationAwareProductUrl(product.url || '', location, product),
      image: product.image || '',
      cityName: product.cityName || '',
      cityKey: product.cityKey || '',
      state: product.state || '',
      stateCode: product.stateCode || '',
    };
  }

  function sortInvitesProducts(products) {
    return (products || []).slice().sort(function (a, b) {
      var cityA = normalizeInvitesCityName(productCityLabel(a) || (a && a.cityName));
      var cityB = normalizeInvitesCityName(productCityLabel(b) || (b && b.cityName));
      var pref = function (city) {
        if (city === 'orange county' || city === 'tustin' || city === 'fairfax') return 0;
        return 1;
      };
      var prefDiff = pref(cityA) - pref(cityB);
      if (prefDiff) return prefDiff;
      var typeA = invitesCatalogWorkshopType(a);
      var typeB = invitesCatalogWorkshopType(b);
      var orderA = INVITES_WORKSHOP_TYPE_ORDER[typeA];
      var orderB = INVITES_WORKSHOP_TYPE_ORDER[typeB];
      if (orderA === undefined) orderA = 9;
      if (orderB === undefined) orderB = 9;
      if (orderA !== orderB) return orderA - orderB;
      return String(a.title || '').localeCompare(String(b.title || ''));
    });
  }

  function locationWithCatalogWorkshops(location, products, catalog) {
    var workshops = sortInvitesProducts(products).map(function (product) {
      return catalogProductToWorkshop(product, catalog, location);
    });
    return Object.assign({}, location, { workshops: workshops });
  }

  function invitesCitySlug(value) {
    var slug = normalizeInvitesCityName(value).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    return slug || 'city';
  }

  function splitLocationByCities(location, products, catalog) {
    var matched = products.filter(function (product) {
      return productMatchesInvitesLocation(product, location);
    });
    if (!matched.length) {
      matched = products.filter(function (product) {
        return productMatchesInvitesLocationState(product, location);
      });
    }
    if (!matched.length) {
      return [locationWithCatalogWorkshops(location, [], catalog)];
    }

    var groups = {};
    var order = [];
    matched.forEach(function (product) {
      var label = productCityLabel(product) || String(product.cityName || '').trim();
      var key = normalizeInvitesCityName(label) || '__state__';
      if (!groups[key]) {
        groups[key] = { label: label || location.title, products: [] };
        order.push(key);
      }
      groups[key].products.push(product);
    });

    if (order.length === 1) {
      var only = groups[order[0]];
      var onlyLabel = only.label || location.title;
      return [
        locationWithCatalogWorkshops(
          Object.assign({}, location, {
            title: onlyLabel,
            city: onlyLabel,
            type: resolveInvitesPinType(
              Object.assign({}, location, { title: onlyLabel, city: onlyLabel })
            ),
          }),
          only.products,
          catalog
        ),
      ];
    }

    return order.map(function (key) {
      var group = groups[key];
      var cityLabel = group.label || location.title;
      var cityLoc = Object.assign({}, location, {
        title: cityLabel,
        city: cityLabel,
      });
      var cityType = resolveInvitesPinType(cityLoc);
      return locationWithCatalogWorkshops(
        Object.assign({}, location, {
          id: location.id + '-' + invitesCitySlug(key === '__state__' ? location.title : cityLabel),
          parentId: location.id,
          type: cityType,
          title: cityLabel,
          city: cityLabel,
          cityNames: key === '__state__' ? location.cityNames : [cityLabel],
          cityKeys: key === '__state__' ? location.cityKeys : [key],
          mapX: cityType === 'store' ? location.mapX : null,
          mapY: cityType === 'store' ? location.mapY : null,
        }),
        group.products,
        catalog
      );
    });
  }

  function invitesCityPreference(location) {
    var city = normalizeInvitesCityName((location && (location.city || location.title)) || '');
    if (city === 'tustin') return 0;
    if (city === 'fairfax') return 0;
    if (city === 'orange county') return 1;
    return 2;
  }

  function isWestStoreCity(label) {
    var city = normalizeInvitesCityName(label);
    return city === 'tustin' || city === 'orange county';
  }

  function isEastStoreCity(label) {
    var city = normalizeInvitesCityName(label);
    return city === 'fairfax';
  }

  function resolveInvitesPinType(location) {
    if (!location) return 'popup';
    if (location.__forcePinType === 'store' || location.__forcePinType === 'popup') {
      return location.__forcePinType;
    }
    var code = String(location.stateCode || '')
      .trim()
      .toUpperCase();
    /* Permanent-shop states only: CA (West) and VA (East). */
    if (code === 'CA') {
      if (String(location.type || '').toLowerCase() === 'store') return 'store';
      if (isWestStoreCity(location.city || location.title)) return 'store';
      return 'popup';
    }
    if (code === 'VA') {
      if (String(location.type || '').toLowerCase() === 'store') return 'store';
      if (isEastStoreCity(location.city || location.title)) return 'store';
      return 'popup';
    }
    return 'popup';
  }

  function pickDefaultInvitesLocation(locations, defaultLocationId) {
    var list = locations || [];
    if (!list.length) return null;

    var withWorkshops = list.filter(function (location) {
      return location.workshops && location.workshops.length;
    });

    if (defaultLocationId) {
      var exact = list.find(function (location) {
        return location.id === defaultLocationId;
      });
      if (exact && exact.workshops && exact.workshops.length) return exact;

      var children = withWorkshops.filter(function (location) {
        return (
          location.parentId === defaultLocationId ||
          (location.id && location.id.indexOf(defaultLocationId + '-') === 0)
        );
      });
      if (children.length) {
        children.sort(function (a, b) {
          return invitesCityPreference(a) - invitesCityPreference(b);
        });
        return children[0];
      }
      if (exact) return exact;
    }

    if (withWorkshops.length) {
      withWorkshops.sort(function (a, b) {
        return invitesCityPreference(a) - invitesCityPreference(b);
      });
      return withWorkshops[0];
    }

    return (
      list.find(function (location) {
        return location.type === 'store';
      }) || list[0]
    );
  }

  function mergeInvitesCatalogWithLocations(data, catalog) {
    var products = (catalog && catalog.products ? catalog.products : []).map(enrichCatalogProduct);
    var locations = [];
    (data.locations || []).forEach(function (location) {
      splitLocationByCities(location, products, catalog).forEach(function (split) {
        locations.push(split);
      });
    });

    return Object.assign({}, data, { locations: locations });
  }

  function readInlineLocationsData(section) {
    var el = section && section.querySelector('[data-amc-invites-locations]');
    if (!el || !el.textContent) return null;
    try {
      var data = JSON.parse(el.textContent);
      return data && data.locations ? data : null;
    } catch (_error) {
      return null;
    }
  }

  function loadLocationsData(section) {
    var catalog = readInvitesCatalog(section);
    var src = section.getAttribute('data-amc-invites-data-src');
    var inline = readInlineLocationsData(section);
    if (!src && !inline) {
      return Promise.reject(new Error('Missing theme locations JSON asset'));
    }

    var catalogPromise = hydrateInvitesCatalog(catalog);
    var locationsPromise = inline
      ? Promise.resolve(inline)
      : fetch(src).then(function (response) {
          if (!response.ok) {
            throw new Error('Locations JSON failed to load');
          }
          return response.json();
        });

    return Promise.all([catalogPromise, locationsPromise]).then(function (results) {
      var hydratedCatalog = results[0];
      var data = results[1];
      section.setAttribute('data-amc-invites-catalog-count', String(hydratedCatalog.catalogCount || 0));
      return mergeInvitesCatalogWithLocations(data, hydratedCatalog);
    });
  }

  function ssrPanelMatchesLocation(panel, location) {
    if (!panel || !location) return false;
    var ssrCity = normalizeInvitesCityName(panel.getAttribute('data-ssr-city') || '');
    var locCity = normalizeInvitesCityName(location.city || location.title || '');
    if (ssrCity && locCity && ssrCity === locCity) return true;

    var ssrId = String(panel.getAttribute('data-location-id') || '');
    var locId = String(location.id || '');
    return !!(ssrId && locId && ssrId === locId);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  var invitesSvgPoint = null;

  function isInsideState(stateEl, svg, x, y) {
    if (!stateEl || !svg || typeof stateEl.isPointInFill !== 'function') return true;
    if (!invitesSvgPoint) invitesSvgPoint = svg.createSVGPoint();
    invitesSvgPoint.x = x;
    invitesSvgPoint.y = y;
    return stateEl.isPointInFill(invitesSvgPoint);
  }

  function pinAnchorTipFits(stateEl, svg, anchorX, anchorY) {
    return isInsideState(stateEl, svg, anchorX, anchorY);
  }

  function distanceBetween(a, b) {
    var dx = (a && a.x || 0) - (b && b.x || 0);
    var dy = (a && a.y || 0) - (b && b.y || 0);
    return Math.sqrt(dx * dx + dy * dy);
  }

  function getPinThemeVars(pinEl) {
    var section = pinEl && pinEl.closest ? pinEl.closest('.amc-invites') : null;
    if (!section) {
      return { lift: 4, activeScale: 1.05 };
    }

    var computed = window.getComputedStyle(section);
    var lift = parseFloat(computed.getPropertyValue('--amc-map-pin-lift'));
    var activeScale = parseFloat(computed.getPropertyValue('--amc-map-pin-active-scale'));

    return {
      lift: isNaN(lift) ? 4 : lift,
      activeScale: isNaN(activeScale) ? 1.05 : activeScale,
    };
  }

  function applyPinInnerTransform(pinInner, pinScale, isActive) {
    if (!pinInner) return;

    var theme = getPinThemeVars(pinInner);
    var offsetX = -24 * pinScale;
    var offsetY = -61 * pinScale;
    var scale = pinScale * (isActive ? theme.activeScale : 1);
    var liftY = isActive ? -theme.lift * pinScale : 0;
    var transform =
      'translate(' +
      offsetX +
      ' ' +
      offsetY +
      ') scale(' +
      scale +
      ')' +
      (liftY ? ' translate(0 ' + liftY + ')' : '');

    pinInner.setAttribute('transform', transform);
  }

  function syncPinInnerTransforms(pins) {
    pins.forEach(function (pinEl) {
      var pinInner = pinEl.querySelector('.amc-map__pin-inner');
      var pinScale = parseFloat(pinEl.getAttribute('data-pin-scale'));
      if (isNaN(pinScale)) {
        pinScale = parseFloat(pinEl.style.getPropertyValue('--amc-map-pin-scale')) || MAP_PIN_BASE_SCALE;
      }
      applyPinInnerTransform(pinInner, pinScale, pinEl.classList.contains('is-active'));
    });
  }

  /* Pin scale is native to each map SVG viewBox (East 1078×984, West 680×720). */
  function getLayoutPinScale(svg) {
    if (!svg || !svg.viewBox || !svg.viewBox.baseVal) {
      return MAP_PIN_BASE_SCALE;
    }

    var vb = svg.viewBox.baseVal;
    if (!vb.width || !vb.height) {
      return MAP_PIN_BASE_SCALE;
    }

    return MAP_PIN_BASE_SCALE;
  }

  function getVisualPinScale(svg, section) {
    return getLayoutPinScale(svg) * getVisualPinMultiplier(section);
  }

  function getLocationsInState(locations, stateIndex) {
    return locations
      .filter(function (location) {
        return location.stateIndex === stateIndex;
      })
      .sort(function (a, b) {
        var typeA = a.type === 'store' ? 0 : 1;
        var typeB = b.type === 'store' ? 0 : 1;
        if (typeA !== typeB) return typeA - typeB;
        return String(a.title || '').localeCompare(String(b.title || ''));
      });
  }

  function bindMapTargets(states, pins, locations, activateState, activateLocation, section) {
    function clearStateHover() {
      states.forEach(function (el) {
        el.classList.remove('is-hovered');
      });
    }

    states.forEach(function (stateEl) {
      var index = parseInt(stateEl.getAttribute('data-state-index'), 10);
      if (isNaN(index)) return;

      var stateLocations = getLocationsInState(locations, index);
      if (!stateLocations.length) return;

      var stateName = getStateDisplayName(index, section);
      stateEl.setAttribute('role', 'button');
      stateEl.setAttribute('tabindex', '0');
      stateEl.setAttribute(
        'aria-label',
        stateName +
          ', ' +
          stateLocations.length +
          ' location' +
          (stateLocations.length === 1 ? '' : 's')
      );

      stateEl.addEventListener('click', function (event) {
        event.stopPropagation();
        activateState(index);
      });

      stateEl.addEventListener('mouseenter', function () {
        clearStateHover();
        if (!stateEl.classList.contains('is-active')) {
          stateEl.classList.add('is-hovered');
        }
      });

      stateEl.addEventListener('mouseleave', function () {
        stateEl.classList.remove('is-hovered');
      });

      stateEl.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          activateState(index);
          if (stateEl.blur) stateEl.blur();
        }
      });
    });

    pins.forEach(function (pinEl) {
      var locationId = pinEl.getAttribute('data-location-id');
      var stateIndex = parseInt(pinEl.getAttribute('data-state-index'), 10);
      if (!locationId && isNaN(stateIndex)) return;

      pinEl.addEventListener('click', function (event) {
        event.stopPropagation();
        /* One pin per state → open state workshop list (same as clicking the state). */
        if (!isNaN(stateIndex)) {
          activateState(stateIndex);
        } else {
          activateLocation(locationId);
        }
        if (pinEl.blur) pinEl.blur();
      });

      pinEl.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          if (!isNaN(stateIndex)) {
            activateState(stateIndex);
          } else {
            activateLocation(locationId);
          }
          if (pinEl.blur) pinEl.blur();
        }
      });
    });
  }

  function refreshPinScales(pins, svg, section) {
    var pinScale = getVisualPinScale(svg, section);
    pins.forEach(function (pinEl) {
      pinEl.setAttribute('data-pin-scale', String(pinScale));
      pinEl.style.setProperty('--amc-map-pin-scale', String(pinScale));
    });
    syncPinInnerTransforms(pins);
  }

  function raiseMapState(stateEl, svg) {
    if (!stateEl || !svg) return;

    var pinsLayer = svg.querySelector('.amc-map__pins-layer');
    if (pinsLayer) {
      svg.insertBefore(stateEl, pinsLayer);
      return;
    }

    svg.appendChild(stateEl);
  }

  function raiseActivePin(pinEl, svg) {
    if (!pinEl || !svg) return;

    var pinsLayer = svg.querySelector('.amc-map__pins-layer');
    if (pinsLayer) {
      pinsLayer.appendChild(pinEl);
    }
  }

  function findStateCenterAnchor(stateEl, svg) {
    if (!stateEl || !svg) return null;
    var box = stateEl.getBBox();
    var slots = getStateSlotPool(stateEl, svg);
    if (slots.length) {
      var sx = 0;
      var sy = 0;
      slots.forEach(function (slot) {
        sx += slot.x;
        sy += slot.y;
      });
      var centroid = { x: sx / slots.length, y: sy / slots.length };
      slots.sort(function (a, b) {
        return distanceBetween(a, centroid) - distanceBetween(b, centroid);
      });
      return slots[0];
    }

    var centerX = box.x + box.width / 2;
    var centerY = box.y + box.height / 2;
    if (pinAnchorTipFits(stateEl, svg, centerX, centerY)) {
      return { x: centerX, y: centerY };
    }
    return { x: centerX, y: centerY };
  }

  function placePinInState(stateEl, svg, preferredX, preferredY, reserved, minDistance) {
    var gap = minDistance == null ? 42 : minDistance;
    if (
      pinAnchorTipFits(stateEl, svg, preferredX, preferredY) &&
      !(reserved || []).some(function (point) {
        return distanceBetween(point, { x: preferredX, y: preferredY }) < gap;
      })
    ) {
      return { x: preferredX, y: preferredY };
    }

    var slots = getStateSlotPool(stateEl, svg).slice();
    var target = { x: preferredX, y: preferredY };
    slots.sort(function (a, b) {
      return distanceBetween(a, target) - distanceBetween(b, target);
    });
    var i;
    for (i = 0; i < slots.length; i++) {
      if (
        !(reserved || []).some(function (point) {
          return distanceBetween(point, slots[i]) < gap;
        })
      ) {
        return slots[i];
      }
    }
    return slots[0] || target;
  }

  function layoutLocationsFromStateBounds(mapRoot, locations) {
    var svg = mapRoot.querySelector('svg');
    if (!svg) return;

    var stateEls = mapRoot.querySelectorAll('.amc-map__state');
    var groups = {};

    locations.forEach(function (location) {
      if (location.stateIndex == null || isNaN(location.stateIndex)) return;
      var key = String(location.stateIndex);
      if (!groups[key]) groups[key] = [];
      groups[key].push(location);
    });

    Object.keys(groups).forEach(function (stateIndexStr) {
      var stateIndex = parseInt(stateIndexStr, 10);
      var stateEl = getMapStateEl(stateEls, stateIndex);
      var group = groups[stateIndexStr].slice().sort(function (a, b) {
        var typeA = resolveInvitesPinType(a) === 'store' ? 0 : 1;
        var typeB = resolveInvitesPinType(b) === 'store' ? 0 : 1;
        if (typeA !== typeB) return typeA - typeB;
        return 0;
      });
      if (!stateEl || !group.length) return;

      var pinScale = getLayoutPinScale(svg);
      var center = findStateCenterAnchor(stateEl, svg) || { x: 0, y: 0 };
      var box = stateEl.getBBox();
      var offsetX = Math.min(Math.max(box.width * 0.14, 22), 40);
      var offsetY = Math.min(Math.max(box.height * 0.1, 18), 34);
      var reserved = [];

      group.forEach(function (location, index) {
        var preferredX = center.x;
        var preferredY = center.y;
        if (group.length > 1) {
          /* Store slightly NW of center, popup SE — both stay inside the state. */
          if (resolveInvitesPinType(location) === 'store') {
            preferredX = center.x - offsetX * 0.35;
            preferredY = center.y - offsetY * 0.2;
          } else {
            preferredX = center.x + offsetX;
            preferredY = center.y + offsetY * 0.35;
          }
        }
        var point = placePinInState(stateEl, svg, preferredX, preferredY, reserved, 40);
        location.mapX = Math.round(point.x);
        location.mapY = Math.round(point.y);
        location.pinScale = pinScale;
        reserved.push(point);
      });
    });
  }

  function buildDynamicPins(mapRoot, locations) {
    var svg = mapRoot.querySelector('svg');
    if (!svg) return [];
    var section = mapRoot.closest('[data-amc-invites-section]');

    mapRoot.querySelectorAll('.amc-map__pin:not(.amc-map__pin--dynamic):not(.amc-map__pin--ssr)').forEach(function (pin) {
      pin.remove();
    });

    var layer = svg.querySelector('.amc-map__pins-layer');
    if (!layer) {
      layer = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      layer.setAttribute('class', 'amc-map__pins-layer');
      svg.appendChild(layer);
    }
    layer.setAttribute('pointer-events', 'auto');

    var ssrPin = layer.querySelector('[data-amc-invites-ssr-pin]');
    layer.querySelectorAll('.amc-map__pin--dynamic:not([data-amc-invites-ssr-pin])').forEach(function (pin) {
      pin.remove();
    });

    var pinElements = [];

    locations.forEach(function (location) {
      if (location.mapX == null || location.mapY == null) return;

      location.type = resolveInvitesPinType(location);
      var pin = null;
      if (
        ssrPin &&
        location.type === 'store' &&
        parseInt(ssrPin.getAttribute('data-state-index'), 10) === location.stateIndex
      ) {
        pin = ssrPin;
        ssrPin = null;
        pin.classList.add('amc-map__pin--dynamic', 'amc-map__pin--store');
        pin.removeAttribute('data-amc-invites-ssr-pin');
      }

      if (!pin) {
        pin = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        pin.setAttribute('class', 'amc-map__pin amc-map__pin--dynamic amc-map__pin--' + location.type);
        var pinInner = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        pinInner.setAttribute('class', 'amc-map__pin-inner');
        pinInner.innerHTML = location.type === 'store' ? STORE_PIN_SVG : POPUP_PIN_SVG;
        pin.appendChild(pinInner);
        layer.appendChild(pin);
      }

      pin.setAttribute('data-location-id', location.id);
      pin.setAttribute('data-state-index', String(location.stateIndex));
      pin.setAttribute('role', 'button');
      pin.setAttribute('tabindex', '0');
      pin.setAttribute(
        'aria-label',
        (location.type === 'store' ? 'Store: ' : 'Pop-up: ') + (location.title || location.id)
      );
      var pinScale = getVisualPinScale(svg, section);
      pin.style.setProperty('--amc-map-pin-scale', String(pinScale));
      pin.setAttribute('transform', 'translate(' + location.mapX + ' ' + location.mapY + ')');
      pin.setAttribute('data-pin-scale', String(pinScale));
      pin.setAttribute('data-map-x', String(location.mapX));
      pin.setAttribute('data-map-y', String(location.mapY));
      applyPinInnerTransform(pin.querySelector('.amc-map__pin-inner'), pinScale, pin.classList.contains('is-active'));
      pinElements.push(pin);
    });

    if (ssrPin) ssrPin.remove();

    return pinElements;
  }

  function buildCarouselNavButton(direction, passive) {
    var isPrev = direction === 'prev';
    var className =
      'amc-invites__carousel-nav amc-carousel-nav amc-invites__carousel-nav--' +
      direction +
      (passive ? ' is-disabled' : '');
    var dataAttr = isPrev ? 'data-amc-invites-prev' : 'data-amc-invites-next';
    var label = isPrev ? 'Previous workshop' : 'Next workshop';
    var symbol = isPrev ? '&lsaquo;' : '&rsaquo;';
    var passiveAttrs = passive ? ' aria-disabled="true" tabindex="-1"' : '';

    return (
      '<button type="button" class="' +
      className +
      '" ' +
      dataAttr +
      ' aria-label="' +
      label +
      '"' +
      passiveAttrs +
      '>' +
      symbol +
      '</button>'
    );
  }

  function buildCarouselNavCluster(hasMultiple) {
    if (!hasMultiple) return '';
    return (
      '<div class="amc-invites__panel-nav" data-amc-invites-nav>' +
      buildCarouselNavButton('prev', false) +
      buildCarouselNavButton('next', false) +
      '</div>'
    );
  }

  function buildPanelHeadHtml(cityLabel, subtitleLabel, extraHeadClass, navHtml) {
    return (
      '<div class="amc-invites__panel-head' +
      (extraHeadClass ? ' ' + extraHeadClass : '') +
      '">' +
      '<div class="amc-invites__panel-head-copy">' +
      '<p class="amc-invites__location-subtitle" data-amc-invites-panel-subtitle>' +
      escapeHtml(subtitleLabel || '') +
      '</p>' +
      (cityLabel
        ? '<p class="amc-invites__location-title" data-amc-invites-panel-title>' +
          escapeHtml(cityLabel) +
          '</p>'
        : '') +
      '</div>' +
      (navHtml || '') +
      '</div>'
    );
  }

  function buildCarouselBlockHtml(slidesHtml, dotsHtml, workshopCount) {
    return (
      '<div class="amc-invites__carousel-shell">' +
      '<div class="amc-invites__carousel" data-amc-invites-carousel>' +
      '<div class="amc-invites__carousel-track" data-amc-invites-track tabindex="0">' +
      slidesHtml +
      '</div>' +
      '<div class="amc-invites__carousel-dots' +
      (workshopCount > 1 ? '' : ' amc-invites__carousel-dots--reserved') +
      '" data-amc-invites-dots' +
      (workshopCount > 1 ? '' : ' aria-hidden="true"') +
      '>' +
      dotsHtml +
      '</div>' +
      '</div>' +
      '</div>'
    );
  }

  function normalizeWorkshopType(workshop) {
    var t = String((workshop && (workshop.type || workshop.workshopType)) || '')
      .toLowerCase()
      .trim();
    if (t === 'resin' || t === 'ceramic' || t === 'mosaic' || t === 'flower') return t;
    if (t === 'workshop') t = '';

    var title = String((workshop && workshop.title) || '').toLowerCase();
    var handle = String((workshop && workshop.handle) || '').toLowerCase();
    var haystack = title + ' ' + handle;
    if (haystack.indexOf('flower') >= 0 || haystack.indexOf('floral') >= 0) return 'flower';
    if (haystack.indexOf('resin') >= 0) return 'resin';
    if (haystack.indexOf('ceramic') >= 0 || haystack.indexOf('painting') >= 0) return 'ceramic';
    if (haystack.indexOf('mosaic') >= 0) return 'mosaic';
    return 'workshop';
  }

  function cacheIconTemplates(section) {
    if (!section || section.__amcInvitesIcons) return;
    var root = section.querySelector('.amc-invites__icon-templates');
    section.__amcInvitesIcons = { resin: '', ceramic: '', mosaic: '' };
    if (!root) return;
    ['resin', 'ceramic', 'mosaic'].forEach(function (type) {
      var el = root.querySelector('[data-amc-invites-icon="' + type + '"]');
      section.__amcInvitesIcons[type] = el ? el.innerHTML.trim() : '';
    });
  }

  function cacheCardImages(section) {
    if (!section || section.__amcInvitesCardImages) return;
    section.__amcInvitesCardImages = {
      mosaic: section.getAttribute('data-card-image-mosaic') || '',
      flower: section.getAttribute('data-card-image-flower') || '',
      resin: section.getAttribute('data-card-image-resin') || '',
      ceramic: section.getAttribute('data-card-image-ceramic') || '',
    };
  }

  function getCardMediaMode(section) {
    var mode = (section && section.getAttribute('data-card-media-mode')) || 'auto';
    if (mode === 'image' || mode === 'video') return mode;
    return 'auto';
  }

  function getCardVideoSettings(section) {
    return {
      autoplay: section.getAttribute('data-card-video-autoplay') === 'true',
      loop: section.getAttribute('data-card-video-loop') === 'true',
      controls: section.getAttribute('data-card-video-controls') === 'true',
    };
  }

  function cacheMediaTemplates(section) {
    if (!section || section.__amcInvitesMediaTemplates) return;
    section.__amcInvitesMediaTemplates = { mosaic: null, resin: null, ceramic: null };
    var root = section.querySelector('.amc-invites__media-templates');
    if (!root) return;

    ['mosaic', 'resin', 'ceramic'].forEach(function (type) {
      var el = root.querySelector('[data-amc-invites-media-template="' + type + '"][data-media-kind="video"]');
      if (!el) return;

      var url = el.getAttribute('data-video-src');
      var poster = el.getAttribute('data-video-poster') || '';
      if (url) {
        section.__amcInvitesMediaTemplates[type] = { html: '', url: url, poster: poster };
        return;
      }

      var html = el.innerHTML.trim();
      if (html) {
        section.__amcInvitesMediaTemplates[type] = { html: html, url: '', poster: poster };
      }
    });
  }

  function themeVideoTemplate(section, workshopType) {
    cacheMediaTemplates(section);
    var templates = section.__amcInvitesMediaTemplates || {};
    return templates[workshopType] || null;
  }

  function ensureVideoA11y(html, label, section) {
    if (!html || html.indexOf('<video') === -1) return html;
    var out = html;
    if (label && out.indexOf('aria-label=') === -1) {
      out = out.replace('<video', '<video aria-label="' + label + '"');
    }
    if (out.indexOf('<track') === -1) {
      var captionsSrc =
        (section && section.getAttribute && section.getAttribute('data-amc-captions-src')) || '';
      if (captionsSrc) {
        out = out.replace(
          '</video>',
          '<track kind="captions" src="' +
            escapeHtml(captionsSrc) +
            '" srclang="en" label="English"></video>'
        );
      }
    }
    if (out.indexOf('<img') !== -1 && out.indexOf('alt=') === -1) {
      out = out.replace('<img ', '<img alt="" ');
    }
    return out;
  }

  function buildVideoFromUrl(url, section, workshop, poster) {
    if (!url) return '';
    var settings = getCardVideoSettings(section);
    var lazy = !settings.autoplay;
    var preload = settings.autoplay ? 'metadata' : 'none';
    var controls = settings.autoplay ? settings.controls : false;
    var attrs =
      'class="amc-invites__video" playsinline muted preload="' +
      preload +
      '"' +
      (lazy ? ' data-amc-lazy-video' : '') +
      (settings.autoplay ? ' autoplay' : '') +
      (settings.loop ? ' loop' : '') +
      (controls ? ' controls' : '');
    var posterAttr = poster ? ' poster="' + escapeHtml(poster) + '"' : '';
    var label = escapeHtml((workshop && workshop.title) || 'Workshop video');
    var captionsSrc =
      (section && section.getAttribute && section.getAttribute('data-amc-captions-src')) || '';
    var track = captionsSrc
      ? '<track kind="captions" src="' + escapeHtml(captionsSrc) + '" srclang="en" label="English">'
      : '';

    return (
      '<video ' +
      attrs +
      posterAttr +
      ' aria-label="' +
      label +
      '"><source src="' +
      escapeHtml(url) +
      '" type="video/mp4">' +
      track +
      '</video>'
    );
  }

  function workshopHasVideoSource(section, workshop) {
    if (workshop && workshop.video) return true;
    var type = normalizeWorkshopType(workshop);
    var tpl = themeVideoTemplate(section, type);
    return !!(tpl && (tpl.html || tpl.url));
  }

  function shouldUseVideo(section, workshop) {
    var mode = getCardMediaMode(section);
    if (mode === 'image') return false;
    if (workshop && workshop.video) return true;
    if (mode === 'video') return workshopHasVideoSource(section, workshop);
    if (section && section.getAttribute('data-card-video-autoplay') !== 'true') return false;
    return workshopHasVideoSource(section, workshop);
  }

  function defaultCardPlaceholderImage(section) {
    cacheCardImages(section);
    var imgs = section.__amcInvitesCardImages || {};
    return imgs.mosaic || imgs.resin || imgs.ceramic || '';
  }

  function workshopCardImage(section, workshop) {
    cacheCardImages(section);
    var imgs = section.__amcInvitesCardImages || {};
    var type = normalizeWorkshopType(workshop);
    if (workshop && workshop.__empty) {
      return defaultCardPlaceholderImage(section);
    }
    if (workshop && workshop.image) return workshop.image;
    if (type && imgs[type]) return imgs[type];
    return imgs.mosaic || imgs.flower || imgs.resin || imgs.ceramic || '';
  }

  function invitesCdnWidth(url, width) {
    var src = String(url || '').trim();
    if (!src || !width) return src;
    if (/[?&]width=\d+/.test(src)) {
      return src.replace(/([?&]width=)\d+/, '$1' + width);
    }
    if (/shopify/i.test(src) && /\.(jpe?g|png|webp|gif)(\?|$)/i.test(src)) {
      return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }
    return src;
  }

  function buildWorkshopImageHtml(src, alt, eager) {
    var w400 = invitesCdnWidth(src, 400);
    var w600 = invitesCdnWidth(src, 600);
    var w800 = invitesCdnWidth(src, 800);
    return (
      '<img class="amc-invites__image" src="' +
      escapeHtml(w600) +
      '" srcset="' +
      escapeHtml(w400) +
      ' 400w, ' +
      escapeHtml(w600) +
      ' 600w, ' +
      escapeHtml(w800) +
      ' 800w" sizes="(max-width: 767px) 42vw, (max-width: 1024px) 280px, 250px" alt="' +
      alt +
      '"' +
      (eager ? ' fetchpriority="high" decoding="sync"' : ' loading="lazy" decoding="async"') +
      ' width="400" height="520">'
    );
  }

  function buildWorkshopMediaHtml(section, workshop) {
    var isEmpty = !!(workshop && workshop.__empty);
    var type = normalizeWorkshopType(workshop);
    var alt = escapeHtml(
      isEmpty ? 'Coming soon' : (workshop && workshop.title) || workshop.type || 'Workshop'
    );

    if (!isEmpty && shouldUseVideo(section, workshop)) {
      if (workshop && workshop.video) {
        var jsonPoster = workshop.videoPoster || workshop.poster || '';
        return buildVideoFromUrl(workshop.video, section, workshop, jsonPoster);
      }

      var tpl = themeVideoTemplate(section, type);
      if (tpl) {
        if (tpl.html) return ensureVideoA11y(tpl.html, alt, section);
        if (tpl.url) return buildVideoFromUrl(tpl.url, section, workshop, tpl.poster);
      }
    }

    var imageSrc = workshopCardImage(section, workshop);
    if (imageSrc) {
      return buildWorkshopImageHtml(imageSrc, alt, !!(workshop && workshop.__eagerImage));
    }

    return '<div class="amc-invites__image amc-invites__image--placeholder" aria-hidden="true"></div>';
  }

  function workshopIconMarkup(section, workshop) {
    if (!section || !section.__amcInvitesIcons) return '';
    var type = normalizeWorkshopType(workshop);
    return section.__amcInvitesIcons[type] || section.__amcInvitesIcons.mosaic || '';
  }

  function stampDecoAssetUrl(section, workshopType) {
    if (!section || !section.dataset) return '';

    var type = normalizeWorkshopType({ type: workshopType });
    if (type === 'resin') return section.dataset.amcInvitesCardDecoResin || '';
    if (type === 'ceramic') return section.dataset.amcInvitesCardDecoCeramic || '';
    return section.dataset.amcInvitesCardDecoMosaic || '';
  }

  function stampDecoHtml(section, workshop) {
    if (!section || !section.dataset) return '';

    var type = normalizeWorkshopType(workshop);
    var url = stampDecoAssetUrl(section, type);
    if (!url) return '';

    return (
      '<div class="amc-invites__stamp-deco amc-invites__stamp-deco--' +
      escapeHtml(type) +
      '" aria-hidden="true">' +
      '<div class="amc-invites__stamp-deco-inner">' +
      '<img class="amc-invites__stamp-deco-img" src="' +
      escapeHtml(url) +
      '" alt="" loading="lazy" width="100" height="100">' +
      '</div></div>'
    );
  }


  function formatEmptyWorkshopTitle(template, city) {
    var title = String(template || '').trim();
    var cityLabel = String(city || '').trim();
    if (!title) title = "Can't find a workshop in {city}";
    title = title.replace(/\?+\s*$/, '').trim();
    if (title.indexOf('{city}') !== -1) {
      return title.split('{city}').join(cityLabel || 'your area');
    }
    if (cityLabel && title.indexOf(cityLabel) === -1) {
      return title;
    }
    return title;
  }


  function invitesEmptyFormEmbed(section) {
    if (!section) return null;
    /* Only the waitlist empty-form hosts — never a bare section-wide form-embed
       (that can steal styling from unrelated Forms embeds on the same page). */
    return (
      section.querySelector(
        '[data-amc-invites-empty-form] form-embed, [data-amc-invites-empty-form] shopify-forms-embed, [data-amc-invites-empty-form] [data-forms-id]'
      ) ||
      section.querySelector(
        '[data-amc-invites-empty-form-host] form-embed, [data-amc-invites-empty-form-host] shopify-forms-embed, [data-amc-invites-empty-form-host] [data-forms-id]'
      )
    );
  }

  function waitlistFieldWrap(field) {
    if (!field || !field.closest) return field && field.parentElement;
    /* Never match form-fields / form-container — hiding those nukes the whole form */
    var wrap = field.closest(
      '[class*="_formField_"]:not([class*="_formFieldset_"]), [class*="formField"]:not([class*="formFieldset"])'
    );
    if (wrap) return wrap;
    var testIdWrap = field.closest('[data-testid]');
    if (testIdWrap) {
      var tid = String(testIdWrap.getAttribute('data-testid') || '').toLowerCase();
      if (
        tid &&
        tid.indexOf('form-fields') === -1 &&
        tid.indexOf('form-container') === -1 &&
        tid.indexOf('form-fieldsets') === -1 &&
        /field/.test(tid)
      ) {
        return testIdWrap;
      }
    }
    return field.parentElement;
  }

  function waitlistActiveEmptySlide(root) {
    if (!root || !root.querySelector) return null;
    var emptySlides = root.querySelectorAll('[data-amc-invites-empty-slide]:not([data-amc-invites-clone])');
    if (!emptySlides.length) return null;
    var track = root.querySelector('[data-amc-invites-track]');
    if (!track) return emptySlides[0];
    var trackLeft = track.scrollLeft;
    var best = emptySlides[0];
    var bestDist = Infinity;
    for (var i = 0; i < emptySlides.length; i++) {
      var slide = emptySlides[i];
      var dist = Math.abs(slide.offsetLeft - trackLeft);
      if (dist < bestDist) {
        bestDist = dist;
        best = slide;
      }
    }
    return best;
  }

  function syncWaitlistLiveFormPosition(live, slot, carousel) {
    if (!live || !slot || !carousel) return;
    var cRect = carousel.getBoundingClientRect();
    var sRect = slot.getBoundingClientRect();
    if (!cRect.width || !sRect.width) return;

    /* Mobile empty stamp scales copy to --amc-wl-inner-scale; live form is outside that transform */
    var scale = 1;
    var stamp = slot.closest('.amc-invites__stamp--empty');
    if (stamp) {
      var raw = window.getComputedStyle(stamp).getPropertyValue('--amc-wl-inner-scale').trim();
      var parsed = parseFloat(raw);
      if (parsed > 0 && parsed < 1) scale = parsed;
    }

    live.style.setProperty('position', 'absolute');
    live.style.setProperty('left', Math.round(sRect.left - cRect.left) + 'px');
    live.style.setProperty('top', Math.round(sRect.top - cRect.top) + 'px');
    live.style.setProperty('height', 'auto');
    live.style.setProperty('z-index', '4');
    live.style.setProperty('margin', '0');
    live.style.setProperty('padding', '0');
    live.style.setProperty('pointer-events', 'auto');

    if (scale < 1) {
      live.style.setProperty('width', Math.round(slot.offsetWidth) + 'px');
      live.style.setProperty('transform', 'scale(' + scale + ')');
      live.style.setProperty('transform-origin', 'top left');
    } else {
      live.style.setProperty('width', Math.round(sRect.width) + 'px');
      live.style.removeProperty('transform');
      live.style.removeProperty('transform-origin');
    }

    /* Slot min-height is layout (pre-scale) so scaled stack clears the form */
    var liveH = live.getBoundingClientRect().height;
    if (liveH > 0) {
      var layoutH = scale < 1 ? liveH / scale : liveH;
      slot.style.setProperty('min-height', Math.ceil(layoutH) + 'px');
    }
  }

  function waitlistFieldMeta(field, scope) {
    var parts = [
      field.getAttribute('type') || '',
      field.getAttribute('name') || '',
      field.getAttribute('id') || '',
      field.getAttribute('placeholder') || '',
      field.getAttribute('aria-label') || '',
      field.getAttribute('data-testid') || '',
      field.hasAttribute('data-amc-invites-waitlist-email') ? 'email' : '',
    ];
    if (field.labels && field.labels.length) {
      for (var lb = 0; lb < field.labels.length; lb++) {
        parts.push(field.labels[lb].textContent || '');
      }
    } else if (field.id && scope && scope.querySelector) {
      var lab = scope.querySelector('label[for="' + String(field.id).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"]');
      if (lab) parts.push(lab.textContent || '');
    }
    var wrap = waitlistFieldWrap(field);
    if (wrap && wrap.querySelectorAll) {
      var labels = wrap.querySelectorAll('label, legend, [class*="Label"], [class*="label"]');
      for (var li = 0; li < labels.length; li++) {
        parts.push(labels[li].textContent || '');
      }
    }
    return parts.join(' ').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function isWaitlistEmailField(meta) {
    return !!meta && /email|e-mail/.test(meta);
  }

  function applyWaitlistEmailPlaceholder(field) {
    if (!field || !field.setAttribute) return;
    field.setAttribute('data-amc-invites-waitlist-email', '');
    field.setAttribute('placeholder', "We'll save you a seat");
    if (!field.getAttribute('aria-label')) field.setAttribute('aria-label', 'Email');
  }

  function isWaitlistCityField(meta) {
    if (!meta || isWaitlistEmailField(meta)) return false;
    return /city\s*workshop|workshop\s*city|\bcity\b|\blocation\b|şehir|sehir|venue/.test(meta);
  }

  function isWaitlistCityLabelText(text) {
    var t = String(text || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/[:*]+$/g, '')
      .trim();
    return t === 'city workshop' || t === 'workshop city' || t === 'city' || t === 'location';
  }

  function setWaitlistFieldValue(field, value) {
    if (!field || value == null) return;
    var tag = (field.tagName || '').toLowerCase();
    if (tag === 'select') {
      var opt = null;
      for (var i = 0; i < field.options.length; i++) {
        if (String(field.options[i].text || '').trim() === value || String(field.options[i].value || '').trim() === value) {
          opt = field.options[i];
          break;
        }
      }
      if (!opt) {
        opt = document.createElement('option');
        opt.value = value;
        opt.textContent = value;
        field.appendChild(opt);
      }
      field.value = opt.value;
    } else if (field.getAttribute('role') === 'combobox' || field.getAttribute('aria-haspopup') === 'listbox') {
      field.textContent = value;
      field.setAttribute('aria-label', value);
      field.value = value;
    } else {
      field.value = value;
    }
    try {
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) {}
  }


  /* Waitlist form — full-width email + Figma dusty-rose pill; sizes via --amc-wl-* (stamp-scaled) */
  var WAITLIST_FORM_CSS =
    '[data-amc-invites-waitlist-hidden],[data-amc-invites-waitlist-hidden] *{' +
    'display:none!important;height:0!important;max-height:0!important;min-height:0!important;' +
    'margin:0!important;padding:0!important;overflow:hidden!important;border:0!important;' +
    'visibility:hidden!important;position:absolute!important;left:-9999px!important;width:0!important;' +
    'flex:0 0 0!important;gap:0!important;pointer-events:none!important;}' +
    ':host{--spacing-size:0px!important;--spacing-size-x:0px!important;--spacing-size-y:0px!important;padding:0!important;}' +
    ':host,form,[data-testid="form-fields"],[data-testid="form-container"],' +
    'section[data-testid="form-container"],[class*="_formContainer_"],[class*="_inline_"],' +
    '[class*="_formFieldset_"],[class*="formFieldset"],' +
    '[class*="_formField_"]:not([class*="_formFieldset_"]),[class*="formField"]:not([class*="formFieldset"]),' +
    '[class*="_grid_"],[class*="_gridItem_"],[class*="_gridItemContent_"],[class*="_container_"]{' +
    'width:100%!important;max-width:100%!important;min-width:0!important;min-height:0!important;height:auto!important;' +
    'box-sizing:border-box!important;align-self:stretch!important;flex:0 0 auto!important;margin:0!important;padding:0!important;}' +
    ':host,form,[data-testid="form-fields"],[data-testid="form-container"],' +
    'section[data-testid="form-container"],[class*="_formContainer_"],[class*="_formFieldset_"],' +
    '[class*="_formField_"],[class*="formField"]{' +
    'background:transparent!important;background-color:transparent!important;box-shadow:none!important;}' +
    'form,[data-testid="form-fields"]{display:flex!important;flex-direction:column!important;align-items:stretch!important;' +
    'justify-content:flex-start!important;gap:var(--amc-wl-gap,10px)!important;min-height:0!important;height:auto!important;}' +
    'label,[class*="formInputFieldLabel"],[class*="InputFieldLabel"],[class*="FieldLabel"],' +
    '[class*="inputLabel"],[class*="floatingLabel"]{' +
    'display:none!important;visibility:hidden!important;opacity:0!important;width:0!important;height:0!important;' +
    'margin:0!important;padding:0!important;overflow:hidden!important;pointer-events:none!important;' +
    'position:absolute!important;left:-9999px!important;}' +
    '[class*="textField"],[class*="TextField"],[class*="inputWrapper"],[class*="InputWrapper"],' +
    '[class*="fieldWrapper"],[class*="FieldWrapper"],[class*="formFieldContainer"]{' +
    'width:100%!important;max-width:none!important;display:block!important;box-sizing:border-box!important;' +
    'background:transparent!important;background-color:transparent!important;background-image:none!important;' +
    'border:none!important;box-shadow:none!important;padding:0!important;}' +
    'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="submit"]),' +
    'textarea,select{' +
    'display:block!important;width:100%!important;max-width:none!important;min-width:0!important;' +
    'box-sizing:border-box!important;align-self:stretch!important;flex:0 0 auto!important;' +
    'min-height:var(--amc-wl-input-h,48px)!important;height:var(--amc-wl-input-h,48px)!important;' +
    'padding:0 20px!important;border:1px solid #e4c9c6!important;border-radius:9999px!important;' +
    'background:#ffffff!important;background-color:#ffffff!important;background-clip:padding-box!important;' +
    'opacity:1!important;' +
    'font-family:"DM Sans",system-ui,sans-serif!important;font-size:15px!important;font-weight:400!important;' +
    'color:#603338!important;-webkit-text-fill-color:#603338!important;caret-color:#603338!important;' +
    'box-shadow:none!important;outline:none!important;appearance:none!important;-webkit-appearance:none!important;}' +
    'input:focus,textarea:focus,select:focus{border-color:#c99395!important;background:#ffffff!important;}' +
    'input::placeholder,textarea::placeholder{color:#a07d80!important;-webkit-text-fill-color:#a07d80!important;opacity:1!important;}' +
    'input::-webkit-contacts-auto-fill-button,input::-webkit-credentials-auto-fill-button,' +
    'input::-webkit-caps-lock-indicator,input::-webkit-strong-password-auto-fill-button{' +
    'visibility:hidden!important;display:none!important;pointer-events:none!important;}' +
    'input:-webkit-autofill,input:-webkit-autofill:hover,input:-webkit-autofill:focus,' +
    'textarea:-webkit-autofill,select:-webkit-autofill{' +
    '-webkit-text-fill-color:#603338!important;caret-color:#603338!important;' +
    'transition:background-color 99999s ease-out 0s!important;' +
    'box-shadow:0 0 0 1000px #ffffff inset!important;}' +
    'form button:not([role="combobox"]):not([aria-haspopup="listbox"]),' +
    'button[type="submit"],' +
    'input[type="submit"],' +
    '[class*="formSubmit"],' +
    '[class*="FormSubmit"],' +
    '[class*="SubmitButton"],' +
    '[class*="submitButton"],' +
    'button[class*="_formButton_"]:not([role="combobox"]):not([aria-haspopup="listbox"]),' +
    'button[class*="formButton"]:not([role="combobox"]):not([aria-haspopup="listbox"]){' +
    'display:inline-flex!important;align-items:center!important;justify-content:center!important;' +
    'box-sizing:border-box!important;width:auto!important;max-width:100%!important;min-width:132px!important;' +
    'align-self:flex-start!important;flex:0 0 auto!important;' +
    'min-height:var(--amc-wl-btn-h,56px)!important;height:var(--amc-wl-btn-h,56px)!important;' +
    'margin:0!important;padding:8px var(--amc-wl-btn-pad-x,24px)!important;' +
    'border:none!important;border-radius:9999px!important;background:#c99395!important;background-color:#c99395!important;' +
    'color:#ffffff!important;' +
    'font-family:"DM Sans",system-ui,sans-serif!important;font-size:var(--amc-wl-btn-fs,14px)!important;font-weight:500!important;' +
    'letter-spacing:0.035px!important;text-transform:uppercase!important;cursor:pointer!important;' +
    'box-shadow:none!important;opacity:1!important;appearance:none!important;-webkit-appearance:none!important;}' +
    '@media screen and (max-width:767px){' +
    'form button:not([role="combobox"]):not([aria-haspopup="listbox"]),' +
    'button[type="submit"],input[type="submit"],' +
    '[class*="formSubmit"],[class*="FormSubmit"],[class*="SubmitButton"],[class*="submitButton"],' +
    'button[class*="_formButton_"]:not([role="combobox"]):not([aria-haspopup="listbox"]),' +
    'button[class*="formButton"]:not([role="combobox"]):not([aria-haspopup="listbox"]){' +
    'align-self:center!important;margin:0 auto 12px!important;min-width:120px!important;}' +
    '}';

  function waitlistScaleMetrics(section) {
    var root = section && section.querySelector ? section.querySelector('[data-amc-invites-panel-root]') || section : null;
    var activeSlide = waitlistActiveEmptySlide(root);
    var stamp =
      (activeSlide && activeSlide.querySelector('.amc-invites__stamp--empty')) ||
      (section && section.querySelector && section.querySelector('.amc-invites__stamp--empty')) ||
      null;
    var w = stamp && stamp.clientWidth ? stamp.clientWidth : 0;
    var mobile = window.matchMedia('(max-width: 767px)').matches;
    if (mobile) {
      return { btnH: 40, btnFs: 12, inputH: 40, gap: 8, padX: 16 };
    }
    var s = w > 0 ? Math.min(1, w / 688) : 1;
    return {
      btnH: Math.round(Math.max(48, 56 * s)),
      btnFs: Math.round(Math.max(12, 14 * s)),
      inputH: Math.round(Math.max(40, 48 * s)),
      gap: Math.round(Math.max(10, 16 * s)),
      padX: Math.round(Math.max(24, 48 * s)),
    };
  }

  function syncWaitlistScaleVars(section) {
    if (!section) return null;
    var m = waitlistScaleMetrics(section);
    var targets = [];
    var root = section.querySelector('[data-amc-invites-panel-root]') || section;
    var activeSlide = waitlistActiveEmptySlide(root);
    var stamp =
      (activeSlide && activeSlide.querySelector('.amc-invites__stamp--empty')) ||
      section.querySelector('.amc-invites__stamp--empty');
    var live = section.querySelector('[data-amc-invites-empty-form-live]');
    var host = section.querySelector('[data-amc-invites-empty-form-host]');
    var embed = invitesEmptyFormEmbed(section);
    if (stamp) targets.push(stamp);
    if (live) targets.push(live);
    if (host) targets.push(host);
    if (embed) targets.push(embed);
    section.querySelectorAll('[data-amc-invites-empty-form-slot]').forEach(function (slotEl) {
      targets.push(slotEl);
    });
    for (var i = 0; i < targets.length; i++) {
      var el = targets[i];
      if (!el || !el.style || !el.style.setProperty) continue;
      el.style.setProperty('--amc-wl-btn-h', m.btnH + 'px');
      el.style.setProperty('--amc-wl-btn-fs', m.btnFs + 'px');
      el.style.setProperty('--amc-wl-input-h', m.inputH + 'px');
      el.style.setProperty('--amc-wl-gap', m.gap + 'px');
      el.style.setProperty('--amc-wl-btn-pad-x', m.padX + 'px');
    }
    return m;
  }

  function invitesSectionId(section) {
    if (!section) return '';
    if (section.dataset && section.dataset.amcInvitesSectionId) {
      return String(section.dataset.amcInvitesSectionId);
    }
    var wrap = section.closest && section.closest('[id^="shopify-section-"]');
    if (wrap && wrap.id) return wrap.id.replace(/^shopify-section-/, '');
    return section.id ? String(section.id) : '';
  }

  function invitesFormStyleKey(section) {
    var sid = invitesSectionId(section);
    if (sid) return 'amc-invites-empty-form-' + sid;
    return 'amc-invites-empty-form-styles';
  }

  function waitlistSectionFromScope(scope) {
    if (!scope) return null;
    if (scope.host && scope.host.closest) {
      return scope.host.closest('[data-amc-invites-section]');
    }
    if (scope.closest) return scope.closest('[data-amc-invites-section]');
    return null;
  }

  function registerWaitlistFormStyles(section) {
    /* Clear only this section's EIF style key — dual West+East must not clobber each other. */
    try {
      if (window.formStyles && typeof window.formStyles.delete === 'function') {
        window.formStyles.delete('amc-invites-waitlist-button');
        window.formStyles.delete(invitesFormStyleKey(section));
      }
    } catch (e) {}
  }

  function ensureWaitlistShadowCss(shadowRoot, section) {
    if (!shadowRoot) return;
    if (!section) section = waitlistSectionFromScope(shadowRoot);
    registerWaitlistFormStyles(section);
    var existing = shadowRoot.querySelector('style[data-amc-invites-waitlist-css]');
    if (existing) existing.remove();
    var a11y = shadowRoot.querySelector('style[data-amc-forms-a11y-css]');
    if (a11y) a11y.remove();
    var style = document.createElement('style');
    style.setAttribute('data-amc-invites-waitlist-css', '');
    var sectionId = invitesSectionId(section);
    if (sectionId) style.setAttribute('data-amc-invites-section-id', sectionId);
    style.textContent = WAITLIST_FORM_CSS;
    shadowRoot.appendChild(style);
    try {
      if (typeof CSSStyleSheet !== 'undefined' && shadowRoot.adoptedStyleSheets) {
        var sheet = new CSSStyleSheet();
        sheet.replaceSync(WAITLIST_FORM_CSS);
        var next = [];
        for (var i = 0; i < shadowRoot.adoptedStyleSheets.length; i++) {
          var s = shadowRoot.adoptedStyleSheets[i];
          if (!s.__amcInvitesWaitlist) next.push(s);
        }
        sheet.__amcInvitesWaitlist = true;
        next.push(sheet);
        shadowRoot.adoptedStyleSheets = next;
      }
    } catch (err) {}
  }

  function isWaitlistSubmitControl(el) {
    if (!el || el.nodeType !== 1) return false;
    var tag = (el.tagName || '').toLowerCase();
    if (tag === 'input' && String(el.type || '').toLowerCase() === 'submit') return true;
    if (tag !== 'button' && !(el.getAttribute && el.getAttribute('role') === 'button')) return false;
    if (el.getAttribute('role') === 'combobox' || el.getAttribute('aria-haspopup') === 'listbox') return false;
    var type = String(el.getAttribute('type') || el.type || '').toLowerCase();
    if (type === 'submit') return true;
    var cls = String(el.className || '');
    /* Do NOT match bare formButton — Shopify Forms uses that class on selects too. */
    if (/formsubmit|submitbutton|submit-button|_submit/i.test(cls)) return true;
    var text = String(el.textContent || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    return text === 'notify me' || text.indexOf('notify') !== -1;
  }

  function stretchWaitlistEl(el) {
    if (!el || !el.style || !el.style.setProperty) return;
    el.style.setProperty('width', '100%', 'important');
    el.style.setProperty('max-width', 'none', 'important');
    el.style.setProperty('min-width', '0', 'important');
    el.style.setProperty('min-height', '0', 'important');
    el.style.setProperty('height', 'auto', 'important');
    el.style.setProperty('box-sizing', 'border-box', 'important');
    el.style.setProperty('align-self', 'stretch', 'important');
    /* Never flex-grow — that leaves a giant hole above the email field */
    el.style.setProperty('flex', '0 0 auto', 'important');
    el.style.setProperty('margin-top', '0', 'important');
  }

  function paintWaitlistSubmit(el, metrics) {
    if (!el || !el.style || !el.style.setProperty) return;
    var m = metrics;
    if (!m) {
      var root = el.getRootNode && el.getRootNode();
      var host = root && root.host ? root.host : null;
      var section =
        (el.closest && el.closest('[data-amc-invites-section], .amc-invites')) ||
        (host && host.closest && host.closest('[data-amc-invites-section], .amc-invites')) ||
        null;
      m = section ? waitlistScaleMetrics(section) : waitlistScaleMetrics(null);
    }
    el.setAttribute('data-amc-invites-waitlist-submit', '');
    el.style.setProperty('display', 'inline-flex', 'important');
    el.style.setProperty('align-items', 'center', 'important');
    el.style.setProperty('justify-content', 'center', 'important');
    el.style.setProperty('width', 'auto', 'important');
    el.style.setProperty('max-width', '100%', 'important');
    el.style.setProperty('min-width', m && window.matchMedia('(max-width: 767px)').matches ? '120px' : '132px', 'important');
    if (window.matchMedia('(max-width: 767px)').matches) {
      el.style.setProperty('align-self', 'center', 'important');
      el.style.setProperty('margin', '0 auto 12px', 'important');
    } else {
      el.style.setProperty('align-self', 'flex-start', 'important');
      el.style.setProperty('margin', '0', 'important');
    }
    el.style.setProperty('flex', '0 0 auto', 'important');
    el.style.setProperty('min-height', m.btnH + 'px', 'important');
    el.style.setProperty('height', m.btnH + 'px', 'important');
    el.style.setProperty('padding', '8px ' + m.padX + 'px', 'important');
    el.style.setProperty('border', 'none', 'important');
    el.style.setProperty('border-radius', '9999px', 'important');
    el.style.setProperty('background', '#c99395', 'important');
    el.style.setProperty('background-color', '#c99395', 'important');
    el.style.setProperty('color', '#ffffff', 'important');
    el.style.setProperty('font-family', '"DM Sans", system-ui, sans-serif', 'important');
    el.style.setProperty('font-size', m.btnFs + 'px', 'important');
    el.style.setProperty('font-weight', '500', 'important');
    el.style.setProperty('letter-spacing', '0.035px', 'important');
    el.style.setProperty('text-transform', 'uppercase', 'important');
    el.style.setProperty('cursor', 'pointer', 'important');
    el.style.setProperty('box-shadow', 'none', 'important');
    el.style.setProperty('opacity', '1', 'important');
    el.style.setProperty('appearance', 'none', 'important');
  }

  function styleWaitlistFullWidth(scope, metrics) {
    if (!scope || !scope.querySelectorAll) return;
    var m = metrics || null;
    var shells = scope.querySelectorAll(
      'form, [data-testid="form-fields"], [data-testid="form-container"], section[data-testid="form-container"], [class*="_formContainer_"], [class*="_formFieldset_"], [class*="_formField_"]:not([class*="_formFieldset_"]), [class*="formField"]:not([class*="formFieldset"]), [class*="textField"], [class*="TextField"], [class*="inputWrapper"], [class*="InputWrapper"]'
    );
    for (var s = 0; s < shells.length; s++) {
      stretchWaitlistEl(shells[s]);
      shells[s].style.setProperty('background', 'transparent', 'important');
      shells[s].style.setProperty('background-color', 'transparent', 'important');
      shells[s].style.setProperty('background-image', 'none', 'important');
      shells[s].style.setProperty('box-shadow', 'none', 'important');
      shells[s].style.setProperty('padding', '0', 'important');
    }

    var fields = scope.querySelectorAll(
      'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="submit"]), textarea, select'
    );
    for (var f = 0; f < fields.length; f++) {
      stretchWaitlistEl(fields[f]);
      fields[f].style.setProperty('display', 'block', 'important');
      fields[f].style.setProperty('max-width', 'none', 'important');
      fields[f].style.setProperty('color', '#603338', 'important');
      fields[f].style.setProperty('-webkit-text-fill-color', '#603338', 'important');
      fields[f].style.setProperty('caret-color', '#603338', 'important');
      fields[f].style.setProperty('background', '#ffffff', 'important');
      fields[f].style.setProperty('background-color', '#ffffff', 'important');
      fields[f].style.setProperty('border', '1px solid #e4c9c6', 'important');
      fields[f].style.setProperty('border-radius', '9999px', 'important');
      fields[f].style.setProperty('padding', '0 20px', 'important');
      fields[f].style.setProperty('opacity', '1', 'important');
      fields[f].style.setProperty('box-shadow', 'none', 'important');
      fields[f].style.setProperty('background-clip', 'padding-box', 'important');
      fields[f].style.setProperty('background-image', 'none', 'important');
      if (isWaitlistEmailField(waitlistFieldMeta(fields[f], scope))) {
        applyWaitlistEmailPlaceholder(fields[f]);
      }
      if (m) {
        fields[f].style.setProperty('min-height', m.inputH + 'px', 'important');
        fields[f].style.setProperty('height', m.inputH + 'px', 'important');
        fields[f].style.setProperty('font-size', '15px', 'important');
      }
    }

    var nodes = scope.querySelectorAll('button, input[type="submit"], [role="button"]');
    for (var i = 0; i < nodes.length; i++) {
      if (isWaitlistSubmitControl(nodes[i])) paintWaitlistSubmit(nodes[i], m);
    }

    hideWaitlistLabels(scope);
  }

  function hideWaitlistLabels(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var labels = scope.querySelectorAll(
      'label, [class*="formInputFieldLabel"], [class*="InputFieldLabel"], [class*="FieldLabel"]'
    );
    for (var i = 0; i < labels.length; i++) {
      labels[i].setAttribute('data-amc-invites-waitlist-hidden', '');
      if (labels[i].style && labels[i].style.setProperty) {
        labels[i].style.setProperty('display', 'none', 'important');
        labels[i].style.setProperty('visibility', 'hidden', 'important');
        labels[i].style.setProperty('opacity', '0', 'important');
      }
    }
  }

  function hideWaitlistNode(node) {
    if (!node || !node.setAttribute) return;
    if (node.querySelector) {
      var keepers = node.querySelectorAll(
        'input[type="email"], input[name*="email"], input[name*="Email"], button[type="submit"], [data-amc-invites-waitlist-submit]'
      );
      if (keepers.length) return;
      var inputs = node.querySelectorAll('input:not([type="hidden"]), textarea');
      for (var k = 0; k < inputs.length; k++) {
        var hint = [
          inputs[k].getAttribute('placeholder') || '',
          inputs[k].getAttribute('aria-label') || '',
          inputs[k].getAttribute('name') || '',
        ]
          .join(' ')
          .toLowerCase();
        if (/email|e-mail/.test(hint)) return;
      }
    }
    node.setAttribute('data-amc-invites-waitlist-hidden', '');
  }

  function walkWaitlistFormScope(scope, city, metrics, section) {
    if (!scope || !scope.querySelectorAll) return;
    if (!section) section = waitlistSectionFromScope(scope);
    if (scope.host) ensureWaitlistShadowCss(scope, section);
    hideWaitlistLabels(scope);
    var fields = scope.querySelectorAll(
      'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="submit"]), textarea, select, button[role="combobox"], button[aria-haspopup="listbox"]'
    );
    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      var meta = waitlistFieldMeta(field, scope);
      var wrap = waitlistFieldWrap(field);
      if (isWaitlistEmailField(meta)) {
        if (wrap) wrap.removeAttribute('data-amc-invites-waitlist-hidden');
        applyWaitlistEmailPlaceholder(field);
      } else {
        /* Stamp waitlist only shows email — hide city / any other field completely */
        if (isWaitlistCityField(meta)) setWaitlistFieldValue(field, city);
        hideWaitlistNode(wrap || field);
      }
    }

    var labelNodes = scope.querySelectorAll('label, legend, p, span, div, [class*="Label"], [class*="label"]');
    for (var j = 0; j < labelNodes.length; j++) {
      var el = labelNodes[j];
      if (!el || el.querySelector('input, textarea, select, button')) continue;
      if (!isWaitlistCityLabelText(el.textContent)) continue;
      hideWaitlistNode(waitlistFieldWrap(el) || el);
    }

    styleWaitlistFullWidth(scope, metrics);
  }

  function applyWaitlistFormCity(section, city) {
    var cityLabel = String(city || '').trim();
    if (!section) return;
    if (cityLabel) section.setAttribute('data-amc-invites-waitlist-city', cityLabel);
    registerWaitlistFormStyles(section);
    var metrics = syncWaitlistScaleVars(section);

    var roots = [];
    var slot = section.querySelector('[data-amc-invites-empty-form]');
    var host = section.querySelector('[data-amc-invites-empty-form-host]');
    if (slot) roots.push(slot);
    if (host) roots.push(host);
    var embed = invitesEmptyFormEmbed(section);
    if (embed) {
      roots.push(embed);
      try {
        embed.style.setProperty('--forms-button-background-color', '#c99395');
        embed.style.setProperty('--forms-button-label-color', '#ffffff');
        embed.style.setProperty('--forms-accent-color', '#c99395');
        embed.style.setProperty('--forms-text-color', '#603338');
        embed.style.setProperty('--forms-input-text-color', '#603338');
        embed.style.setProperty('--forms-field-text-color', '#603338');
        embed.style.setProperty('color', '#603338');
      } catch (e) {}
    }

    roots.forEach(function (root) {
      walkWaitlistFormScope(root, cityLabel, metrics, section);
      if (!root.querySelectorAll) return;
      root.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) walkWaitlistFormScope(el.shadowRoot, cityLabel, metrics, section);
      });
      if (root.shadowRoot) walkWaitlistFormScope(root.shadowRoot, cityLabel, metrics, section);
    });

  }

  function bindWaitlistStampResize(section, panelRoot) {
    if (!section || typeof ResizeObserver === 'undefined') return;
    var root = panelRoot || section.querySelector('[data-amc-invites-panel-root]') || section;
    var activeSlide = waitlistActiveEmptySlide(root);
    var stamp =
      (activeSlide && activeSlide.querySelector('.amc-invites__stamp--empty')) ||
      root.querySelector('.amc-invites__stamp--empty');
    if (!stamp) return;

    if (!section.__amcInvitesWaitlistResize) {
      section.__amcInvitesWaitlistResize = new ResizeObserver(function () {
        applyWaitlistFormCity(section, activeWaitlistCity(section, root));
      });
    }
    if (section.__amcInvitesWaitlistResizeStamp && section.__amcInvitesWaitlistResizeStamp !== stamp) {
      section.__amcInvitesWaitlistResize.unobserve(section.__amcInvitesWaitlistResizeStamp);
    }
    section.__amcInvitesWaitlistResize.observe(stamp);
    section.__amcInvitesWaitlistResizeStamp = stamp;
  }

  function unbindWaitlistStampResize(section) {
    if (!section || !section.__amcInvitesWaitlistResize) return;
    if (section.__amcInvitesWaitlistResizeStamp) {
      section.__amcInvitesWaitlistResize.unobserve(section.__amcInvitesWaitlistResizeStamp);
      section.__amcInvitesWaitlistResizeStamp = null;
    }
  }

  function activeWaitlistCity(section, panelRoot) {
    var root = panelRoot || section;
    var titleEl = root && root.querySelector ? root.querySelector('[data-amc-invites-panel-title]') : null;
    if (titleEl && titleEl.textContent) return String(titleEl.textContent).trim();
    var slide = waitlistActiveEmptySlide(root);
    if (slide) return String(slide.getAttribute('data-amc-invites-slide-city') || '').trim();
    return String((section && section.getAttribute('data-amc-invites-waitlist-city')) || '').trim();
  }

  function unbindWaitlistFormWatch(section) {
    if (!section || !section.__amcInvitesWaitlistFormWatch) return;
    section.__amcInvitesWaitlistFormWatch.disconnect();
    section.__amcInvitesWaitlistFormWatch = null;
    section.__amcInvitesWaitlistFormWatchLive = null;
  }

  function bindWaitlistFormWatch(section, live, root) {
    if (!section || !live) return;
    if (section.__amcInvitesWaitlistFormWatch && section.__amcInvitesWaitlistFormWatchLive === live) {
      return;
    }
    unbindWaitlistFormWatch(section);
    section.__amcInvitesWaitlistFormWatchLive = live;
    section.__amcInvitesWaitlistFormWatch = new MutationObserver(function () {
      applyWaitlistFormCity(
        section,
        section.getAttribute('data-amc-invites-waitlist-city') || activeWaitlistCity(section, root)
      );
    });
    section.__amcInvitesWaitlistFormWatch.observe(live, { childList: true, subtree: true });
  }

  function parkInvitesEmptyForm(section) {
    if (!section || !section.querySelector) return;
    unbindWaitlistStampResize(section);
    unbindWaitlistFormWatch(section);
    var host = section.querySelector('[data-amc-invites-empty-form-host]');
    var embed = invitesEmptyFormEmbed(section);
    if (host && embed && embed.parentElement !== host) {
      host.appendChild(embed);
    }
  }

  function invitesPanelNeedsWaitlistForm(root) {
    if (!root || !root.querySelector) return false;
    if (root.querySelector('.amc-invites__panel--waitlist')) return true;
    var track = root.querySelector('[data-amc-invites-track]');
    var slides = root.querySelectorAll('[data-amc-invites-slide]:not([data-amc-invites-clone])');
    if (!slides.length) return false;
    var left = track ? track.scrollLeft : 0;
    var active = slides[0];
    var bestDist = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var dist = Math.abs((slides[i].offsetLeft || 0) - left);
      if (dist < bestDist) {
        bestDist = dist;
        active = slides[i];
      }
    }
    return active.hasAttribute('data-amc-invites-empty-slide');
  }

  function mountInvitesEmptyFormIfNeeded(section, panelRoot) {
    if (!section) return;
    var root = panelRoot || section.querySelector('[data-amc-invites-panel-root]') || section;
    if (!invitesPanelNeedsWaitlistForm(root)) {
      parkInvitesEmptyForm(section);
      return;
    }
    mountInvitesEmptyForm(section, root);
  }

  function mountInvitesEmptyForm(section, panelRoot) {
    if (!section) return;
    var host = section.querySelector('[data-amc-invites-empty-form-host]');
    if (!host) return;

    var embed = invitesEmptyFormEmbed(section);
    if (!embed) {
      if (!host.__amcInvitesFormObserver) {
        host.__amcInvitesFormObserver = new MutationObserver(function () {
          if (invitesEmptyFormEmbed(section) && host.__amcInvitesFormObserver) {
            host.__amcInvitesFormObserver.disconnect();
            host.__amcInvitesFormObserver = null;
          }
          mountInvitesEmptyFormIfNeeded(section, panelRoot);
        });
        host.__amcInvitesFormObserver.observe(host, { childList: true, subtree: false });
      }
      return;
    }

    var root = panelRoot || section.querySelector('[data-amc-invites-panel-root]') || section;
    var emptySlides = root.querySelectorAll('[data-amc-invites-empty-slide]:not([data-amc-invites-clone])');
    if (!emptySlides.length) {
      if (embed.parentElement !== host) host.appendChild(embed);
      return;
    }

    var activeSlide = waitlistActiveEmptySlide(root);
    var slot =
      (activeSlide && activeSlide.querySelector('[data-amc-invites-empty-form-slot]')) ||
      root.querySelector('[data-amc-invites-empty-form-slot]');
    if (!slot) {
      if (embed.parentElement !== host) host.appendChild(embed);
      return;
    }

    var live = slot.querySelector('[data-amc-invites-empty-form-live]');
    if (!live) {
      live = document.createElement('div');
      live.className = 'amc-invites__empty-form amc-invites__empty-form--live';
      live.setAttribute('data-amc-invites-empty-form', '');
      live.setAttribute('data-amc-invites-empty-form-live', '');
      slot.appendChild(live);
    }
    if (embed.parentElement !== live) {
      live.appendChild(embed);
    }
    slot.removeAttribute('aria-hidden');

    var city =
      (activeSlide && activeSlide.getAttribute('data-amc-invites-slide-city')) ||
      activeWaitlistCity(section, root);
    applyWaitlistFormCity(section, city);
    bindWaitlistStampResize(section, root);
    bindWaitlistFormWatch(section, live, root);
  }

  function readEmptyWorkshopCopy(section) {
    var title = "Can't find a workshop in {city}";
    var message = "Leave your email and we'll let you know when a workshop opens nearby.";

    if (section && section.dataset) {
      if (section.dataset.amcInvitesEmptyTitle) {
        title = section.dataset.amcInvitesEmptyTitle;
      }
      if (section.dataset.amcInvitesEmptyMessage) {
        message = section.dataset.amcInvitesEmptyMessage;
      }
    }

    return {
      title: String(title || 'Coming soon').trim() || 'Coming soon',
      message: String(message || 'Workshops coming soon.').trim() || 'Workshops coming soon.',
    };
  }

  function emptyWorkshopSlide(section, location) {
    var copy = readEmptyWorkshopCopy(section);
    var city = workshopDisplayCity({ __empty: true, __location: location }, location) || '';
    if (!city && location) {
      city = String(location.city || location.title || location.name || '').trim();
    }
    return {
      title: formatEmptyWorkshopTitle(copy.title, city),
      description: copy.message,
      buttonLabel: '',
      link: '',
      __empty: true,
      __location: location || null,
    };
  }

  function buildWorkshopSlide(workshop, showBadge, section, location, slideIndex) {
    var isEmpty = !!(workshop && workshop.__empty);
    if (!isEmpty && slideIndex < 3) {
      workshop = Object.assign({}, workshop, { __eagerImage: true });
    }
    var mediaHtml = isEmpty ? '' : buildWorkshopMediaHtml(section, workshop);
    var decoHtml = showBadge && !isEmpty ? stampDecoHtml(section, workshop) : '';
    var displayCity = workshopDisplayCity(workshop, location);
    var displaySubtitle = workshopDisplaySubtitle(workshop, location);
    var cardTitle = isEmpty
      ? String((workshop && workshop.title) || formatEmptyWorkshopTitle(readEmptyWorkshopCopy(section).title, displayCity))
      : workshopCardTitle(workshop, location);

    var pricesHtml = '';
    if (workshop.compareAtPrice || workshop.price) {
      pricesHtml =
        '<div class="amc-invites__prices">' +
        (workshop.compareAtPrice
          ? '<span class="amc-invites__compare-price">' + escapeHtml(workshop.compareAtPrice) + '</span>'
          : '') +
        (workshop.price ? '<span class="amc-invites__price">' + escapeHtml(workshop.price) + '</span>' : '') +
        '</div>';
    }

    var buttonLabel = workshop.buttonLabel || 'Book now';
    var buttonHtml = '';
    if (!isEmpty) {
      buttonHtml = workshop.link
        ? '<a class="amc-invites__button" href="' + escapeHtml(workshop.link) + '">' + escapeHtml(buttonLabel) + '</a>'
        : '<span class="amc-invites__button amc-invites__button--disabled" aria-disabled="true">' +
          escapeHtml(buttonLabel) +
          '</span>';
    }

    var stackHtml = '';
    if (cardTitle) {
      stackHtml += '<h3 class="amc-invites__card-title">' + escapeHtml(cardTitle) + '</h3>';
    }
    if (workshop.description) {
      stackHtml +=
        '<div class="amc-invites__card-text rte"><p>' + escapeHtml(workshop.description) + '</p></div>';
    }
    if (pricesHtml) stackHtml += pricesHtml;
    if (buttonHtml) stackHtml += buttonHtml;

    var copyHtml = '';
    if (stackHtml) {
      copyHtml =
        '<div class="amc-invites__stamp-copy">' +
        '<div class="amc-invites__stamp-copy-stack">' +
        stackHtml +
        '</div></div>';
    }

    if (isEmpty) {
      var emptyStack =
        (cardTitle ? '<h3 class="amc-invites__card-title">' + escapeHtml(cardTitle) + '</h3>' : '') +
        (workshop.description
          ? '<div class="amc-invites__card-text rte"><p>' + escapeHtml(workshop.description) + '</p></div>'
          : '') +
        '<div class="amc-invites__empty-form-slot" data-amc-invites-empty-form-slot></div>';

      return (
        '<article class="amc-invites__slide amc-invites__slide--empty" data-amc-invites-slide' +
        (displayCity ? ' data-amc-invites-slide-city="' + escapeHtml(displayCity) + '"' : '') +
        (displaySubtitle ? ' data-amc-invites-slide-subtitle="' + escapeHtml(displaySubtitle) + '"' : '') +
        (location && location.id
          ? ' data-amc-invites-slide-location="' + escapeHtml(location.id) + '"'
          : '') +
        ' data-amc-invites-empty-slide>' +
        '<div class="amc-invites__stamp amc-invites__stamp--empty">' +
        '<div class="amc-invites__stamp-inner">' +
        '<div class="amc-invites__stamp-surface" aria-hidden="true"></div>' +
        '<div class="amc-invites__stamp-copy amc-invites__stamp-copy--empty">' +
        '<div class="amc-invites__stamp-copy-stack">' +
        emptyStack +
        '</div></div></div></div></article>'
      );
    }

    return (
      '<article class="amc-invites__slide' +
      '" data-amc-invites-slide' +
      (displayCity ? ' data-amc-invites-slide-city="' + escapeHtml(displayCity) + '"' : '') +
      (displaySubtitle ? ' data-amc-invites-slide-subtitle="' + escapeHtml(displaySubtitle) + '"' : '') +
      (location && location.id
        ? ' data-amc-invites-slide-location="' + escapeHtml(location.id) + '"'
        : '') +
      '>' +
      '<div class="amc-invites__stamp">' +
      '<div class="amc-invites__stamp-inner">' +
      '<div class="amc-invites__stamp-surface" aria-hidden="true"></div>' +
      copyHtml +
      '<div class="amc-invites__media">' +
      mediaHtml +
      '</div>' +
      decoHtml +
      '</div>' +
      '</div>' +
      '</article>'
    );
  }

  function collectStateWorkshops(stateLocations, section) {
    var workshops = [];

    stateLocations.forEach(function (location) {
      var locWorkshops = location.workshops || [];
      if (!locWorkshops.length) {
        workshops.push(emptyWorkshopSlide(section, location));
        return;
      }

      locWorkshops.forEach(function (workshop) {
        workshops.push(Object.assign({}, workshop, { __location: location }));
      });
    });

    return workshops;
  }

  function buildStatePanelHtml(stateIndex, stateLocations, showBadge, section) {
    var stateName = getStateDisplayName(stateIndex, section);
    var workshops = collectStateWorkshops(stateLocations, section);

    if (!workshops.length) {
      workshops = [emptyWorkshopSlide(section, null)];
    }

    var firstWorkshop = workshops[0] || null;
    var cityLabel = workshopDisplayCity(firstWorkshop, firstWorkshop && firstWorkshop.__location);
    var subtitleLabel = workshopDisplaySubtitle(firstWorkshop, firstWorkshop && firstWorkshop.__location) || stateName;

    var slides = workshops
      .map(function (workshop, index) {
        return buildWorkshopSlide(workshop, showBadge, section, workshop.__location || null, index);
      })
      .join('');

    var dots = workshops
      .map(function (_workshop, index) {
        return (
          '<button type="button" class="amc-invites__carousel-dot' +
          (index === 0 ? ' is-active' : '') +
          '" data-amc-invites-dot="' +
          index +
          '" aria-label="Show workshop ' +
          (index + 1) +
          '"' +
          (index === 0 ? ' aria-current="true"' : '') +
          '></button>'
        );
      })
      .join('');

    return (
      '<div class="amc-invites__panel amc-invites__panel--state' +
      (firstWorkshop && firstWorkshop.__empty ? ' amc-invites__panel--waitlist' : '') +
      ' is-active" data-amc-invites-panel data-amc-invites-state-panel data-state-index="' +
      stateIndex +
      '">' +
      buildPanelHeadHtml(
        cityLabel,
        subtitleLabel,
        'amc-invites__panel-head--state',
        buildCarouselNavCluster(workshops.length > 1)
      ) +
      buildCarouselBlockHtml(slides, dots, workshops.length) +
      '</div>'
    );
  }

  function buildPanelHtml(location, showBadge, section) {
    var workshops = location.workshops || [];
    if (!workshops.length) {
      workshops = [emptyWorkshopSlide(section, location)];
    }
    var firstWorkshop = workshops[0] || null;
    var cityLabel = workshopDisplayCity(firstWorkshop, location);
    var subtitleLabel = workshopDisplaySubtitle(firstWorkshop, location);

    var slides = workshops
      .map(function (workshop, index) {
        return buildWorkshopSlide(workshop, showBadge, section, location, index);
      })
      .join('');

    var dots = workshops
      .map(function (_workshop, index) {
        return (
          '<button type="button" class="amc-invites__carousel-dot' +
          (index === 0 ? ' is-active' : '') +
          '" data-amc-invites-dot="' +
          index +
          '" aria-label="Show workshop ' +
          (index + 1) +
          '"' +
          (index === 0 ? ' aria-current="true"' : '') +
          '></button>'
        );
      })
      .join('');

    return (
      '<div class="amc-invites__panel' +
      (firstWorkshop && firstWorkshop.__empty ? ' amc-invites__panel--waitlist' : '') +
      ' is-active" data-amc-invites-panel data-location-id="' +
      escapeHtml(location.id) +
      '">' +
      buildPanelHeadHtml(
        cityLabel,
        subtitleLabel,
        '',
        buildCarouselNavCluster(workshops.length > 1)
      ) +
      buildCarouselBlockHtml(slides, dots, workshops.length) +
      '</div>'
    );
  }

  function bindPassiveNavButtons(panelRoot) {
    if (!panelRoot) return;

    panelRoot.querySelectorAll('[data-amc-invites-prev], [data-amc-invites-next]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        if (btn.classList.contains('is-disabled') || btn.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    });
  }

  function fitInvitesPanelHead(root) {
    if (!root || !root.querySelector) return;
    var head = root.querySelector('.amc-invites__panel-head');
    var copy = root.querySelector('.amc-invites__panel-head-copy');
    var title = root.querySelector('[data-amc-invites-panel-title], .amc-invites__location-title');
    var subtitle = root.querySelector('[data-amc-invites-panel-subtitle], .amc-invites__location-subtitle');
    var nav = root.querySelector('.amc-invites__panel-nav');
    if (!copy || !title) return;

    title.style.fontSize = '';
    if (subtitle) subtitle.style.fontSize = '';

    var available = copy.clientWidth;
    if (available < 8 && head) {
      available = Math.max(0, head.clientWidth - (nav ? nav.offsetWidth + 12 : 0));
    }
    if (available < 8) return;

    var gap = parseFloat(window.getComputedStyle(copy).columnGap || window.getComputedStyle(copy).gap) || 8;
    var titleSize = parseFloat(window.getComputedStyle(title).fontSize) || 24;
    var subSize = subtitle ? parseFloat(window.getComputedStyle(subtitle).fontSize) || 14 : 0;
    var minTitle = 13;
    var minSub = 10;
    var steps = 0;

    function usedWidth() {
      return title.scrollWidth + (subtitle ? gap + subtitle.scrollWidth : 0);
    }

    while (usedWidth() > available + 0.5 && steps < 36) {
      steps += 1;
      var nextTitle = Math.max(minTitle, titleSize * 0.88);
      var nextSub = subtitle ? Math.max(minSub, subSize * 0.88) : 0;
      if (nextTitle === titleSize && nextSub === subSize) break;
      titleSize = nextTitle;
      subSize = nextSub;
      title.style.fontSize = titleSize + 'px';
      if (subtitle) subtitle.style.fontSize = subSize + 'px';
    }
  }

  function fitInvitesCardTitles(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.amc-invites__slide:not(.amc-invites__slide--empty) .amc-invites__card-title').forEach(function (title) {
      title.style.fontSize = '';
      title.style.whiteSpace = 'nowrap';
      var available = title.clientWidth;
      if (available < 8) return;
      var size = parseFloat(window.getComputedStyle(title).fontSize) || 28;
      var min = 13;
      var steps = 0;
      while (title.scrollWidth > available + 0.5 && size > min && steps < 24) {
        steps += 1;
        size = Math.max(min, size * 0.92);
        title.style.fontSize = size + 'px';
      }
    });
  }

  function scheduleFitInvitesPanelHead(root) {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        fitInvitesPanelHead(root);
        fitInvitesCardTitles(root);
      });
    });
  }

  function invitesInteractiveTarget(target) {
    return !!(target && target.closest && target.closest('a, button, input, textarea, select, label'));
  }

  function bindInvitesBookNowLinks(panelRoot) {
    if (!panelRoot || !panelRoot.querySelectorAll) return;
    panelRoot.querySelectorAll('.amc-invites__button[href]').forEach(function (link) {
      if (link.dataset.amcInvitesLinkBound === '1') return;
      link.dataset.amcInvitesLinkBound = '1';
      link.addEventListener(
        'pointerdown',
        function (event) {
          event.stopPropagation();
        },
        true
      );
    });
  }

  function initPanelCarousel(panelRoot, autoplayMs, section) {
    section = section || (panelRoot && panelRoot.closest && panelRoot.closest('[data-amc-invites-section]'));
    if (!panelRoot) return;
    var panelGeneration = panelRoot.__amcInvitesPanelGeneration || 0;

    var carousel = panelRoot.querySelector('[data-amc-invites-carousel]');
    var track = panelRoot.querySelector('[data-amc-invites-track]');
    var slides = track
      ? Array.prototype.slice.call(track.querySelectorAll('[data-amc-invites-slide]:not([data-amc-invites-clone])'))
      : [];
    var dotsWrap = panelRoot.querySelector('[data-amc-invites-dots]');
    var prevBtn = panelRoot.querySelector('[data-amc-invites-prev]');
    var nextBtn = panelRoot.querySelector('[data-amc-invites-next]');
    if (!track || slides.length <= 1) {
      bindInvitesBookNowLinks(panelRoot);
      scheduleFitInvitesPanelHead(panelRoot);
      mountInvitesEmptyFormIfNeeded(section, panelRoot);
      return;
    }

    bindInvitesBookNowLinks(panelRoot);

    if (track.dataset.amcInvitesCarouselBound === '1') {
      scheduleFitInvitesPanelHead(panelRoot);
      mountInvitesEmptyFormIfNeeded(section, panelRoot);
      return;
    }
    track.dataset.amcInvitesCarouselBound = '1';

    var index = 0;
    var autoplayTimer = null;
    var autoplayStoppedByUser = false;
    var wrapping = false;
    var wrapQueued = null;
    var lastNavAt = 0;
    var pinHighlightTimer = null;
    var dragging = false;
    var firstClone = null;
    var lastClone = null;

    function prefersReducedMotion() {
      try {
        return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      } catch (_error) {
        return false;
      }
    }

    function motionBehavior(behavior) {
      if (prefersReducedMotion()) return 'auto';
      return behavior || 'smooth';
    }

    function markClone(clone, kind) {
      clone.setAttribute('data-amc-invites-clone', kind);
      clone.setAttribute('aria-hidden', 'true');
      clone.style.pointerEvents = 'none';
      clone.querySelectorAll('a, button, input, textarea, select').forEach(function (el) {
        el.setAttribute('tabindex', '-1');
        el.setAttribute('aria-hidden', 'true');
      });
      return clone;
    }

    if (!isMobileMapViewport()) {
      firstClone = markClone(slides[0].cloneNode(true), 'first');
      lastClone = markClone(slides[slides.length - 1].cloneNode(true), 'last');
      track.insertBefore(lastClone, slides[0]);
      track.appendChild(firstClone);
    }

    function setScrollLeftInstant(left) {
      track.style.scrollBehavior = 'auto';
      track.style.scrollSnapType = 'none';
      track.scrollLeft = left;
      window.requestAnimationFrame(function () {
        track.scrollLeft = left;
        track.style.scrollSnapType = '';
        track.style.scrollBehavior = '';
      });
    }

    function waitNear(targetLeft, cb) {
      var done = false;
      var poll = window.setInterval(function () {
        if (Math.abs(track.scrollLeft - targetLeft) <= 8) finish();
      }, 32);
      var safety = window.setTimeout(finish, 1100);
      function finish() {
        if (done) return;
        done = true;
        window.clearInterval(poll);
        window.clearTimeout(safety);
        track.removeEventListener('scrollend', finish);
        cb();
      }
      track.addEventListener('scrollend', finish);
    }

    function updateDots() {
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('[data-amc-invites-dot]').forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function updatePanelHeading() {
      if (panelRoot.__amcInvitesPanelGeneration !== panelGeneration) return;

      var slide = slides[index];
      if (!slide) return;

      var city = slide.getAttribute('data-amc-invites-slide-city') || '';
      var subtitle = slide.getAttribute('data-amc-invites-slide-subtitle') || '';
      var titleEl = panelRoot.querySelector('[data-amc-invites-panel-title]');
      var subtitleEl = panelRoot.querySelector('[data-amc-invites-panel-subtitle]');
      var panelEl = panelRoot.querySelector('[data-amc-invites-panel]') || panelRoot.firstElementChild;
      var isWaitlist = slide.hasAttribute('data-amc-invites-empty-slide');

      if (panelEl) panelEl.classList.toggle('amc-invites__panel--waitlist', isWaitlist);
      if (titleEl && city) titleEl.textContent = city;
      if (subtitleEl) subtitleEl.textContent = subtitle || '';
      if (isWaitlist) {
        var waitlistCity = section.getAttribute('data-amc-invites-waitlist-city') || '';
        if (waitlistCity !== city || !invitesPanelNeedsWaitlistForm(panelRoot)) {
          mountInvitesEmptyForm(section, panelRoot);
          applyWaitlistFormCity(section, city);
        }
      }
      scheduleFitInvitesPanelHead(panelRoot);
      var locationId = slide.getAttribute('data-amc-invites-slide-location') || '';
      if (pinHighlightTimer) window.clearTimeout(pinHighlightTimer);
      pinHighlightTimer = window.setTimeout(function () {
        pinHighlightTimer = null;
        if (panelRoot.__amcInvitesPanelGeneration !== panelGeneration) return;
        if (typeof section.__amcHighlightInvitesPin === 'function') {
          section.__amcHighlightInvitesPin(locationId, city);
        }
      }, 90);
    }

    function updateSlideFade() {
      track.querySelectorAll('.amc-invites__slide').forEach(function (slide) {
        slide.style.opacity = '';
      });
      track.classList.remove('is-sliding');
    }

    function jumpToIndex(realIndex) {
      index = realIndex;
      var slide = slides[index];
      if (!slide) return;
      setScrollLeftInstant(slide.offsetLeft);
      updateSlideFade();
      updateDots();
      updatePanelHeading();
    }

    function nearestRealIndex() {
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var dist = Math.abs(slides[i].offsetLeft - track.scrollLeft);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return { index: best, dist: bestDist };
    }

    function settleFromClones() {
      if (!firstClone || !lastClone) return false;
      var firstDist = Math.abs(firstClone.offsetLeft - track.scrollLeft);
      var lastDist = Math.abs(lastClone.offsetLeft - track.scrollLeft);
      var nearest = nearestRealIndex();
      if (firstDist + 2 < nearest.dist) {
        jumpToIndex(0);
        return true;
      }
      if (lastDist + 2 < nearest.dist) {
        jumpToIndex(slides.length - 1);
        return true;
      }
      return false;
    }

    function wrapIndex(value) {
      var count = slides.length;
      if (!count) return 0;
      return ((value % count) + count) % count;
    }

    function finishWrap() {
      wrapping = false;
      updateSlideFade();
      var queued = wrapQueued;
      wrapQueued = null;
      if (queued != null && queued !== index) {
        scrollToIndex(queued, 'auto');
        return;
      }
      mountInvitesEmptyFormIfNeeded(section, panelRoot);
    }

    function scrollToIndex(nextIndex, behavior) {
      var count = slides.length;
      if (!count) return;
      var now = Date.now();
      var rapid = now - lastNavAt < 200;
      lastNavAt = now;

      if (wrapping) {
        wrapQueued = wrapIndex(nextIndex);
        return;
      }

      var useBehavior = rapid ? 'auto' : motionBehavior(behavior);
      var step = slides[0] ? slides[0].offsetWidth : track.clientWidth;

      if (!firstClone) {
        nextIndex = wrapIndex(nextIndex);
      }

      if (nextIndex >= count && firstClone) {
        if (rapid) {
          jumpToIndex(0);
          return;
        }
        wrapping = true;
        index = 0;
        updateDots();
        updatePanelHeading();
        var forwardLeft = firstClone.offsetLeft || (slides[count - 1].offsetLeft + step);
        track.style.scrollSnapType = 'none';
        track.scrollTo({ left: forwardLeft, behavior: useBehavior });
        waitNear(forwardLeft, function () {
          setScrollLeftInstant(slides[0].offsetLeft);
          finishWrap();
        });
        return;
      }

      if (nextIndex < 0 && lastClone) {
        if (rapid) {
          jumpToIndex(count - 1);
          return;
        }
        wrapping = true;
        index = count - 1;
        updateDots();
        updatePanelHeading();
        var backLeft = lastClone.offsetLeft;
        track.style.scrollSnapType = 'none';
        track.scrollTo({ left: backLeft, behavior: useBehavior });
        waitNear(backLeft, function () {
          setScrollLeftInstant(slides[count - 1].offsetLeft);
          finishWrap();
        });
        return;
      }

      index = Math.max(0, Math.min(nextIndex, count - 1));
      var slide = slides[index];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: useBehavior });
      updateDots();
      updatePanelHeading();
    }

    function stepNav(delta) {
      if (wrapping) {
        wrapQueued = wrapIndex((wrapQueued == null ? index : wrapQueued) + delta);
        return;
      }
      scrollToIndex(index + delta);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function stopAutoplayFromUserNav() {
      autoplayStoppedByUser = true;
      stopAutoplay();
    }

    function startAutoplay() {
      stopAutoplay();
      if (autoplayStoppedByUser || !autoplayMs || autoplayMs < 500) return;
      if (prefersReducedMotion()) return;
      autoplayTimer = window.setInterval(function () {
        stepNav(1);
      }, autoplayMs);
    }

    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (event) {
        var dot = event.target.closest('[data-amc-invites-dot]');
        if (!dot) return;
        var dotIndex = parseInt(dot.getAttribute('data-amc-invites-dot'), 10);
        if (isNaN(dotIndex)) return;
        scrollToIndex(dotIndex);
        startAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        stopAutoplayFromUserNav();
        stepNav(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        stopAutoplayFromUserNav();
        stepNav(1);
      });
    }

    var startX = 0;
    var startY = 0;
    var startScroll = 0;
    var pointerId = null;
    var moved = false;
    var suppressClick = false;
    var axisLocked = '';

    function onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (invitesInteractiveTarget(event.target)) return;
      dragging = true;
      moved = false;
      suppressClick = false;
      axisLocked = '';
      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      try {
        track.setPointerCapture(event.pointerId);
      } catch (_error) {}
      stopAutoplayFromUserNav();
    }

    function onPointerMove(event) {
      if (!dragging) return;
      var dx = startX - event.clientX;
      var dy = startY - event.clientY;
      if (!axisLocked) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        axisLocked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
      if (axisLocked !== 'x') return;
      event.preventDefault();
      if (Math.abs(dx) > 6) moved = true;
      track.scrollLeft = startScroll + dx;
    }

    function onPointerUp(event) {
      if (!dragging) return;
      var didMove = moved;
      dragging = false;
      track.classList.remove('is-dragging');
      try {
        if (pointerId != null) track.releasePointerCapture(pointerId);
      } catch (_error) {}
      pointerId = null;
      moved = false;
      if (axisLocked === 'x' && didMove) {
        suppressClick = true;
      }
      if (axisLocked !== 'x' || !didMove) {
        axisLocked = '';
        return;
      }
      var dx = startX - event.clientX;
      if (dx > 40) stepNav(1);
      else if (dx < -40) stepNav(-1);
      else scrollToIndex(index);
      axisLocked = '';
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove, { passive: false });
    track.addEventListener('pointerup', onPointerUp);
    track.addEventListener('pointercancel', onPointerUp);
    track.addEventListener(
      'click',
      function (event) {
        if (invitesInteractiveTarget(event.target)) return;
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      },
      true
    );

    var scrollTimer;
    track.addEventListener(
      'scroll',
      function () {
        updateSlideFade();
        if (wrapping || dragging) return;
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          if (wrapping || dragging) return;
          if (panelRoot.__amcInvitesPanelGeneration !== panelGeneration) return;
          if (settleFromClones()) return;
          index = nearestRealIndex().index;
          updateDots();
          updatePanelHeading();
        }, 80);
      },
      { passive: true }
    );

    if (carousel) {
      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);
      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('focusout', startAutoplay);
    }

    if (typeof ResizeObserver !== 'undefined') {
      var resizeWatch = new ResizeObserver(function () {
        scheduleFitInvitesPanelHead(panelRoot);
        if (wrapping || dragging) return;
        var slide = slides[index];
        if (slide) setScrollLeftInstant(slide.offsetLeft);
      });
      resizeWatch.observe(track);
      var headCopy = panelRoot.querySelector('.amc-invites__panel-head-copy');
      if (headCopy) resizeWatch.observe(headCopy);
    }

    setScrollLeftInstant(slides[0].offsetLeft);
    window.requestAnimationFrame(function () {
      if (slides[0]) setScrollLeftInstant(slides[0].offsetLeft);
      updateSlideFade();
    });
    updateSlideFade();
    updateDots();
    updatePanelHeading();
    startAutoplay();
  }

  function initInvitesMap(section) {
    if (!section || section.dataset.amcInvitesInit === 'true') return;
    if (section.__amcInvitesInitPending) return;
    section.__amcInvitesInitPending = true;

    unbindWaitlistFormWatch(section);
    unbindWaitlistStampResize(section);
    section.__amcHighlightState = null;
    section.__amcHighlightLocId = null;

    section.__amcInvitesIcons = null;
    section.__amcInvitesCardImages = null;
    section.__amcInvitesMediaTemplates = null;

    var mapRoot = section.querySelector('[data-amc-invites-map]');
    var panelRoot = section.querySelector('[data-amc-invites-panel-root]');
    if (!mapRoot || !panelRoot) return;

    var stateColorsEarly = parseStateColors(section);
    var placeholderPanel = panelRoot.querySelector('[data-state-index]');
    if (placeholderPanel) {
      var placeholderStateIndex = parseInt(placeholderPanel.getAttribute('data-state-index'), 10);
      if (!isNaN(placeholderStateIndex)) {
        applyStateTheme(section, placeholderStateIndex, stateColorsEarly);
      }
    }

    var autoplayMs = parseInt(section.getAttribute('data-amc-invites-autoplay') || '8000', 10);
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      autoplayMs = 0;
    }

    var dataPromise = loadLocationsData(section);
    var mapPromise = loadMapSvg(mapRoot);

    function paintDefaultPanel(data) {
      if (!data) return null;
      cacheIconTemplates(section);
      cacheCardImages(section);
      cacheMediaTemplates(section);
      var locations = data.locations || [];
      var showBadge = section.getAttribute('data-amc-invites-show-badge') === 'true';
      var defaultLocation = pickDefaultInvitesLocation(locations, data.defaultLocationId);
      if (!defaultLocation) return null;
      if (section.__amcInvitesDefaultPainted) return defaultLocation;

      section.__amcInvitesDefaultPainted = true;
      section.dataset.amcInvitesPanelReady = 'true';
      section.setAttribute('data-amc-invites-view', 'location');

      var ssrPanel = panelRoot.querySelector('[data-amc-invites-ssr-panel]');
      if (ssrPanel && ssrPanelMatchesLocation(ssrPanel, defaultLocation)) {
        ssrPanel.setAttribute('data-location-id', defaultLocation.id);
        ssrPanel.querySelectorAll('[data-amc-invites-slide]').forEach(function (slide) {
          slide.setAttribute('data-amc-invites-slide-location', defaultLocation.id);
        });
        bindPassiveNavButtons(panelRoot);
        mountInvitesEmptyFormIfNeeded(section, panelRoot);
        initPanelCarousel(panelRoot, autoplayMs, section);
        applyStateTheme(section, defaultLocation.stateIndex, parseStateColors(section));
        return defaultLocation;
      }

      panelRoot.__amcInvitesPanelGeneration = (panelRoot.__amcInvitesPanelGeneration || 0) + 1;
      parkInvitesEmptyForm(section);
      panelRoot.innerHTML = buildPanelHtml(defaultLocation, showBadge, section);
      bindPassiveNavButtons(panelRoot);
      mountInvitesEmptyFormIfNeeded(section, panelRoot);
      initPanelCarousel(panelRoot, autoplayMs, section);
      applyStateTheme(section, defaultLocation.stateIndex, parseStateColors(section));
      return defaultLocation;
    }

    dataPromise.then(paintDefaultPanel).catch(function () {});

    Promise.all([mapPromise, dataPromise])
      .then(function (results) {
        if (section.dataset.amcInvitesInit === 'true') return;
        section.dataset.amcInvitesInit = 'true';

        var data = results[1];
        var locations = data.locations || [];
        var showBadge = section.getAttribute('data-amc-invites-show-badge') === 'true';

        cacheIconTemplates(section);
        cacheCardImages(section);
        cacheMediaTemplates(section);
        var pinLocations = locationsForMapPins(locations);
        layoutLocationsFromStateBounds(mapRoot, pinLocations);

        var states = mapRoot.querySelectorAll('.amc-map__state');
        var stateColors = parseStateColors(section);
        var pins = buildDynamicPins(mapRoot, pinLocations);
        var mapSvg = mapRoot.querySelector('svg');
        var locationById = {};

        locations.forEach(function (location) {
          locationById[location.id] = location;
        });
        /* Pin may point at a state row that city-split replaced — keep pin targets resolvable. */
        pinLocations.forEach(function (location) {
          if (location && location.id && !locationById[location.id]) {
            locationById[location.id] = location;
          }
        });

        function clearMapActive() {
          states.forEach(function (stateEl) {
            stateEl.classList.remove('is-active', 'is-hovered');
          });
          pins.forEach(function (pinEl) {
            pinEl.classList.remove('is-active', 'is-state-active');
          });
        }

        function highlightStatePins(stateIndex) {
          if (stateIndex == null || isNaN(stateIndex)) return;
          /* Pins follow the active state — not the carousel city. */
          if (section.__amcHighlightState === stateIndex) return;

          section.__amcHighlightState = stateIndex;
          section.__amcHighlightLocId = '';

          var svg = mapRoot.querySelector('svg');
          clearMapActive();
          applyActiveMapStateFill(states, stateIndex, stateColors, section);
          var activeState = getMapStateEl(states, stateIndex);
          if (activeState) {
            activeState.classList.add('is-active');
            raiseMapState(activeState, svg);
          }
          applyStateTheme(section, stateIndex, stateColors);

          pins.forEach(function (pinEl) {
            var pinSameState = parseInt(pinEl.getAttribute('data-state-index'), 10) === stateIndex;
            pinEl.classList.toggle('is-active', pinSameState);
            pinEl.classList.remove('is-state-active');
            if (pinSameState) raiseActivePin(pinEl, svg);
          });

          syncPinInnerTransforms(pins);
        }

        function highlightLocationPin(locationId, city) {
          var match = locationId ? locationById[locationId] : null;
          if (!match && city) {
            var cityKey = normalizeInvitesCityName(city);
            match = locations.find(function (location) {
              return (
                normalizeInvitesCityName(location.city || location.title) === cityKey ||
                normalizeInvitesCityName(location.title) === cityKey
              );
            });
          }
          if (!match || match.stateIndex == null) return;
          highlightStatePins(match.stateIndex);
        }

        section.__amcHighlightInvitesPin = highlightLocationPin;

        function isCurrentLocationPanel(location) {
          if (!location || section.getAttribute('data-amc-invites-view') === 'state') return false;
          var panel = panelRoot.querySelector('[data-amc-invites-panel]');
          if (!panel || panel.hasAttribute('data-amc-invites-state-panel')) return false;
          var currentId = panel.getAttribute('data-location-id') || '';
          if (currentId && currentId === location.id) return true;
          return ssrPanelMatchesLocation(panel, location);
        }

        function activateLocation(locationId) {
          var location = locationById[locationId];
          if (!location) return;

          if (isCurrentLocationPanel(location)) {
            highlightStatePins(location.stateIndex);
            return;
          }

          panelRoot.__amcInvitesPanelGeneration = (panelRoot.__amcInvitesPanelGeneration || 0) + 1;
          parkInvitesEmptyForm(section);
          panelRoot.innerHTML = buildPanelHtml(location, showBadge, section);
          bindPassiveNavButtons(panelRoot);
          mountInvitesEmptyFormIfNeeded(section, panelRoot);
          initPanelCarousel(panelRoot, autoplayMs, section);
          section.setAttribute('data-amc-invites-view', 'location');
          highlightStatePins(location.stateIndex);
        }

        function activateState(stateIndex) {
          var stateLocations = getLocationsInState(locations, stateIndex);
          if (!stateLocations.length) return;

          var statePanel = panelRoot.querySelector('[data-amc-invites-state-panel]');
          var currentState = statePanel && parseInt(statePanel.getAttribute('data-state-index'), 10);
          if (
            section.getAttribute('data-amc-invites-view') === 'state' &&
            statePanel &&
            currentState === stateIndex
          ) {
            highlightStatePins(stateIndex);
            return;
          }

          panelRoot.__amcInvitesPanelGeneration = (panelRoot.__amcInvitesPanelGeneration || 0) + 1;
          parkInvitesEmptyForm(section);
          panelRoot.innerHTML = buildStatePanelHtml(stateIndex, stateLocations, showBadge, section);
          bindPassiveNavButtons(panelRoot);
          mountInvitesEmptyFormIfNeeded(section, panelRoot);
          initPanelCarousel(panelRoot, autoplayMs, section);
          section.setAttribute('data-amc-invites-view', 'state');
          highlightStatePins(stateIndex);
        }

        bindMapTargets(states, pins, locations, activateState, activateLocation, section);
        mapRoot.classList.remove('amc-invites__map--placeholder');

        var mobileMq = window.matchMedia(MOBILE_MAP_MQ);
        var onPinViewportChange = function () {
          refreshPinScales(pins, mapSvg, section);
        };
        if (typeof mobileMq.addEventListener === 'function') {
          mobileMq.addEventListener('change', onPinViewportChange);
        } else if (typeof mobileMq.addListener === 'function') {
          mobileMq.addListener(onPinViewportChange);
        }

        var defaultLocation = paintDefaultPanel(data) || pickDefaultInvitesLocation(locations, data.defaultLocationId);

        if (defaultLocation) {
          highlightStatePins(defaultLocation.stateIndex);
        }
      })
      .catch(function () {
        section.__amcInvitesInitPending = false;
        section.classList.add('amc-invites--data-error');
      });
  }

  function boot() {
    /* Script itself is intersect-loaded; do not add a second observer. */
    document.querySelectorAll('[data-amc-invites-section]').forEach(initInvitesMap);
  }

  window.__amcInvitesMapBoot = boot;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-amc-invites-section]');
    if (section) {
      section.dataset.amcInvitesInit = 'false';
      section.dataset.amcInvitesPanelReady = 'false';
      section.__amcInvitesDefaultPainted = false;
      initInvitesMap(section);
    }
  });
})();
